import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoginService } from '../login/login.service';
import { HeaderService } from '../header/header.service';
import { AppSettings } from '../../config/config';
import { AdmissionService } from '../admission/admission.service';
import { FeeManagementService } from '../feesmanage/feesmanage.service';
import { FormValidator } from '../form.validator';
import { TransportService } from '../transport/transport.service';
import { GroupService } from '../groups/groups.service';
import { Offcanvas } from '../form.offcanvas';
import { ScriptLoader } from '../script-loader';
import * as registrationStrings from "../stringFiles/registration.json";
import * as tcGenerationString from "../stringFiles/tcGeneration.json";
import { commonFunctionService } from '../utils/commonFunctions';
import parsePhoneNumberFromString from 'libphonenumber-js/max';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Output, EventEmitter } from '@angular/core';
import { BrandService } from '../brand/brand.service';
import { SchoolInfoService } from '../header/school-info.service';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;
declare var materialadmin: any;
declare var window: any;
declare var document: any;

interface AcademicYearObj {
    pkAcademicId: number;
    Year: string;
}

interface CategoryObj {
    categoryId: number;
    categoryName: string;
}

interface ClassSectionObj {
    classId: number;
    className: string;
    classDivision: string;
}

@Component({
    selector: 'app-header-v2',
    templateUrl: './header-v2.component.html',
    styleUrls: [
        './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
        './header-v2.component.css'
    ],
    providers: [LoginService, HeaderService, AdmissionService, GroupService, LoginService,
        TransportService, FeeManagementService, FormValidator, Offcanvas, ScriptLoader]
})
export class HeaderV2Component implements OnInit {
    @ViewChild("mobileNumber") mobileNumberInput: ElementRef;
     @Output() onClearSelections = new EventEmitter<void>();

    toggleMobileMenu() {
        document.body.classList.toggle('menubar-visible');
    }

    strings: any;
    tcGenerationStringsData: any;
    brand = this.brandService.brand;
    constructor(
        private schoolInfoService: SchoolInfoService,
        private commonFunction: commonFunctionService, private router: Router, private loginservice: LoginService, private elRef: ElementRef,
        private headerservice: HeaderService, private admissionservice: AdmissionService,
        private formValidator: FormValidator, private transportservice: TransportService,
        private groupservice: GroupService, private cdr: ChangeDetectorRef, private scriptLoader: ScriptLoader,private translate: TranslateService,
        private eLangDropDownRef: ElementRef, private brandService: BrandService
    ) {
        this.transferCertificateEnables = localStorage.getItem("transferCertificate");
        this.idCardServiceEnables = localStorage.getItem("idCardService");
        this.staffIdCardServiceEnables = localStorage.getItem('staffIdCardService');
        this.mTotalFees = '0';
        this.tcGenerationStringsData = tcGenerationString;
        this.strings = registrationStrings;
    }

    handleKeyDown(event: KeyboardEvent) {
        this.commonFunction.handleKeyDown(event);
    }

    // fetch cookie value from cookie data
    getCookieValue(cookieName) {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [key, value] = cookie.split("=");
            if (key === cookieName) {
                return decodeURIComponent(value);
            }
        }
        return null;
    }

    /*variables for edit start*/
    preLoader = false;
    subscriptionDetails: any;
    // new variables
    getAuthToken: any
    getSchoolId: any
    isFranchise: any
    fkFranchiseId: any

    academicId = 0;
    schoolAcademicCurrentYear;
    transferCertificateEnables: string = "";
    idCardServiceEnables : string = "";
    staffIdCardServiceEnables: string = "";

    permissions: any;
    months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    isTcGenerationConfirm: boolean = false;


    loader = false;
    schoolCategories = [];
    schoolClassStdList = [];
    selectedCategory = null;
    selectedClass = null;
    selectedSectionAdd = null;
    avalialableTermsList = [];
    studentSelectedTerms = [];
    viewStudentTerms = [];
    viewStudentTermIds = [];
    isTermsVisible = false;

    schoolAllClass = [];
    editMobileNumber: string = ""

    // add new student variables
    profileImageSelected = false;
    profileImageSelectedForStaff = false;


    pkStaffQualificationId = null;
    studentCategoryListForAdmission = [];

    private URL = AppSettings.API_ENDPOINT;

    busListData = [];
    busStopListData = [];
    selectedBusId = 0;
    selectedBusStopId = 0;
    mTotalBusFeesForEdit = 0;
    studentMobileNumber: any
    /*variables for edit end*/
    getSchoolName = '';
    getSchoolImage = '';
    getSchoolState = '';
    getSchoolLocality = '';

    /*Admission variables*/
    currentSchoolId: any;
    selectedAcademicYearObj = null;
    academicYearsList: [AcademicYearObj];
    // selectedCategory          =   null;
    categoryList: [CategoryObj];
    classSectionList: [ClassSectionObj];
    selectedClassSection = null;
    selectedClassSectionId = null;
    selectedBusRoute = null;
    selectedBusStop = null;
    feesComponentsList = [];
    addAmountStatus = true;
    applyAmountStatus = false;
    mTotalFees = '0';
    mTotalBusFees = '0';
    feesAmount = 0;
    mFeesComponentName = '';
    mFeesComponentDue = '';
    mFeesComponentAmount = '0';

    admissionStudentImage = 'assets/img/avatar-students.png';

    mStudentName = '';
    mSurName;
    mCast: string = "General";
    mGenderGroup = '1';
    mDOB;
    mBloodGroup = 'A+';
    mReligion = 'Hindu';
    mNationality = 'Indian';
    mCountryCode = this.brand.defaultCountryDialCode || '91';
    mStudentEmail;
    mStudenNumber;
    mFatherName;
    mFatherNumber;
    mFatherOccupation;
    mFatherQualification;
    mFatherEmail = null;
    mFatherAddress = '';
    mMotherName;
    mMotherNumber;
    mCountryCodeFather = this.brand.defaultCountryDialCode || '91';
    mCountryCodeMother = this.brand.defaultCountryDialCode || '91';
    mMotherOccupation;
    mMotherQualification;
    mMotherSameFatherAddress;
    mMotherAddress = '';
    mGuardianName;
    mGuardianNumber;
    mCountryCodeGuardian = this.brand.defaultCountryDialCode || '91';
    mGuardianOccupation;
    mGuardianQualification;
    mGuardianSameFatherAddress;
    mGuardianAddress;
    mAdmissionBase;
    mAdmissionStream = 'general';
    mAdmissionNumber;
    mAdmissionDate;
    mMotherEmail = null;
    mGuardianEmail;
    mBusId;
    mStudenAadharNumber;
    addNewStudentPENNumber: string = "";
    addNewFatherPinCode: string = "";
    addNewStudentFatherAnnualIncome: string = "";
    addNewStudentMotherAnnualIncome: string = "";
    addNewStudentIsSingleGirlChild: boolean = false;
    addNewIsMinority: boolean = false;
    addNewStudentIsSpeciallyDisabled: boolean = false;
    addNewStudentIsEWS: boolean = false;
    addNewGuardianPinCode: string = "";
    addNewMotherPinCode: string = "";
    addNewStudentGuardianAnnualIncome: string = "";
    tcGeneratedJob: boolean = false;
    tcJobId: string = ""

    tab1activestatus = true;
    tab2activestatus;
    tab3activestatus;
    tab4activestatus;
    tab5activestatus;

    tab1donestatus;
    tab2donestatus;
    tab3donestatus;
    tab4donestatus;
    tab5donestatus;

    selectedAcademicYear = '';
    admissionBase = 'written';

    nextTabStatus1 = false;
    nextTabStatus2 = false;
    classSections = null;
    selectedBusTerms = [];
    houseNameList = [];
    generateStudentRegistrationId = 'MANUAL';
    projectDebounceTimer: any;
    invalidMobileNumber: boolean = false
    addStudentMobileNumber: string = "";
    addStudentMobileNumberParsed: string = ""
    addStudentFatherMobileNumberInput: string = "";
    invalidAddStudentFatherMobileNumber: boolean = false;
    addNewStudentMotherNumberInput: string = "";
    invalidAddStudentMotherMobileNumber: boolean = false
    addNewStudentGuardianNumberInput: string = "";
    invalidAddStudentGuardianMobileNumber: boolean = false;
    studentCountryCode = this.brand.defaultCountryDialCode || '91';
    motherCountryCode = this.brand.defaultCountryDialCode || '91';
    guardianCountryCode = this.brand.defaultCountryDialCode || '91';
    /*EDIT STUDENT VARIABLES START*/

    editStudentFormData = {
        categories: [], classStandards: [], sections: [],
        student: {
            houseName: null,
            categoryId: null,
            aadharCopy: null,
            aadharNumber: '',
            studentImage: 'https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png',
            fkClassStandardsId: null,
            classId: '0',
            dateOfAdmission: '',
            dateOfBirth: '',
            countryCode: this.brand.defaultCountryDialCode || '91',
            studentName: '',
            surname: '',
            studentEmail: '',
            studentPhone: '',
            registrationId: '',
            gender: 0,
            rollNumber: '',
            isAppUser: 0,
            isBlocked: 0,
            parentName: '',
            mobileNumber: '',
            fatherOccupation: '',
            fatherQualification: '',
            address: '',
            motherName: '',
            motherPhone: '',
            motherOccupation: '',
            motherQualification: '',
            motherAddress: '',
            stopId: null,
            studentId: null,
            busId: null,
            guardianName: '',
            guardianPhone: '',
            guardianOccupation: '',
            guardianQualification: '',
            guardianAddress: ''
        },
        deactivateReasons: []
    };
    busListDataEditStudent = [];

    nStudentSelectedTerms = [];
    loaderEditStudent = false;
    isCreateNewAdmission = false;
    admissionObj = null;
    mCallback = null;
    updateStudentClassChangeError = { oldClassName: '', structureName: '', newClassName: '', paidAmount: '', feeStrutureId: null };
    /*EDIT STUDENT VARIABLES END*/

    classConfigPercentage = 0;
    classConfigList = [];
    isProcessing = false;
    loginMode = '';

    classConfigSearchTerm = '';
    classConfigOnlyIncomplete = false;
    classConfigTotalModules = 7;
    classConfigPageSize = 10;
    classConfigPageSizeOptions = [10, 25, 50];

    idCardDetails: any;

    currentYear;
    currType = 'INR';
    countryCode: string;
    // update selected student details
    editStuCounTryCode = '';

    editStudentLoadStatus = false;
    staffName = '';

    // token auth
    isValidToken() {
        let isValidToken = false;
        let isValidSchool = 0;
        if (this.getSchoolId) {
            this.loginservice.isValidToken(localStorage.getItem('usertoken'))
                .subscribe(
                    (data: any) => {
                        isValidToken = data.isValid;
                        if (data.errorcode === 10010) {
                            this.router.navigate(['/suspended']);
                        } else if (isValidToken === true) {
                            this.subscriptionDetails = data.subscriptionDetails;
                            this.loginservice.isValidSchoolId(localStorage.getItem('schoolinfo'))
                                .subscribe(
                                    (validData: any) => {
                                        isValidSchool = validData.schoolExist;
                                        this.getSchoolId = localStorage.getItem('schoolinfo');
                                        if (isValidSchool !== 1) {
                                            this.router.navigate(['/login']);
                                        } else {
                                            // Get School Info
                                            this.headerservice.schoolInfo(this.getSchoolId, localStorage.getItem('usertoken'))
                                                .subscribe(
                                                    (schoolData: any) => {
                                                        localStorage.setItem('academicStartDate', schoolData.currentAcademicStartDate);
                                                        localStorage.setItem('extensionServices', schoolData.schoolExtensionServicePermissions ? JSON.stringify(schoolData.schoolExtensionServicePermissions) : null);
                                                        localStorage.setItem("schoolAllInfo", JSON.stringify(schoolData));
                                                        this.getSchoolName = schoolData.schoolName;
                                                        this.schoolInfoService.set({ schoolName: schoolData.schoolName || '', schoolImage: schoolData.schoolImage || '', state: schoolData.state || '', locality: schoolData.locality || '' });
                                                        localStorage.setItem('franchiseName', this.getSchoolName);
                                                        this.getSchoolImage = schoolData.schoolImage;
                                                        this.getSchoolState = schoolData.state;
                                                        this.getSchoolLocality = schoolData.locality;
                                                        localStorage.setItem('isFeeDashboardFeatureEnabled',schoolData.isFeeDashboardFeatureEnabled)
                                                        
                                                        console.log("this.staffName::",this.staffName);
                                                        
                                                        this.getClassConfigStatus();
                                                        this.getAllAcademicYears();
                                                        this.getAllCategories();
                                                        this.getCurrentAcademic(this.currentSchoolId);
                                                        // this.getAllStops();
                                                        // this.getAllAvailableStopTerms();
                                                    },
                                                    error => {
                                                        localStorage.setItem('isFeeDashboardFeatureEnabled', 'false');
                                                    }
                                                );
                                        }
                                    },
                                    error => {
                                    }
                                );
                        } else {
                            this.router.navigate(['/login']);
                        }
                    },
                    error => {
                    }
                );
        }

    }

    get isAcademicRunning(): boolean {
        return $("body").attr("data-academic-state") === "RUNNING";
    }

    getAllAvailableStopTerms() {
    
        this.transportservice.getAvailableStopTerms(localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    if (data.success) {
                        this.avalialableTermsList = data.data;
                    }
                },
                error => {

                }
            );
    }

    dateFormat(num) {
        if (num < 10) {
            return '0' + num;
        } else {
            return num;
        }
    }

    formatDate(date) {
        let d = new Date();
        if (date && date !== '') {
            d = new Date(date);
        }
        return '' + this.months[d.getMonth()] + ' ' + d.getDate() + ',' + d.getFullYear();
    }

    onBusTermChanged(event, termId) {
        termId = parseInt(termId)
        const isChecked = event.currentTarget.checked;
        if (this.selectedBusTerms.indexOf(termId) !== -1 && isChecked === false) {
            const index = this.selectedBusTerms.indexOf(termId);
            this.selectedBusTerms.splice(index, 1);
        } else {
            this.selectedBusTerms.push(termId);
        }
    }

    onBusTermChangedSelectAll(event) {
        const isChecked = event.currentTarget.checked;
        this.selectedBusTerms = [];
        for (const item of this.avalialableTermsList) {
            item.isSelectedTerm = isChecked;
            if (isChecked === true) {
                this.selectedBusTerms.push(item.pkBusStopTermId);
            }
        }
    }

    getFatherNumberForAdmission(copy) {
        this.mMotherNumber = copy ? this.mFatherNumber : '';
    }

    changeStudName(mStudentName) {
        const validationMessage = this.formValidator.validateFieldName(mStudentName, "Student");
        if (validationMessage) {
            // this.errorMessage.studentNameError = validationMessage;
            $('#admission-student-name').addClass('input-validator');
            customToastr(validationMessage, "error")
        } else {
            // this.errorMessage.studentNameError = ""
            $('#admission-student-name').removeClass('input-validator');
        }
    }

    changeSurName(mSurName) {
        if ($.isNumeric(mSurName)) {
            $('#admission-surname').addClass('input-validator');
        } else {
            $('#admission-surname').removeClass('input-validator');
        }
    }


    changeDOB() {
        this.mDOB = $('#admission-dob').val();
        const validateMessage = this.formValidator.valdateDOB(this.mDOB)
        if (validateMessage) {
            $('#admission-dob').addClass('input-validator');
            customToastr(validateMessage, 'error')
        } else {
            $('#admission-dob').removeClass('input-validator');
        }
    }

    changeCaste(mCast) {
        if ($.isNumeric(mCast)) {
            $('#admission-cast').addClass('input-validator');
        } else {
            $('#admission-cast').removeClass('input-validator');
        }
    }

    changeEmail(mStudentEmail) {
        if (this.formValidator.validateIsData(mStudentEmail) && !this.formValidator.validateIsEmail(mStudentEmail)) {
            $('#admission-student-email').addClass('input-validator');
        } else {
            $('#admission-student-email').removeClass('input-validator');
        }
    }

    changeFatherEmail(mFatherEmail) {
        if (this.formValidator.validateIsData(mFatherEmail) && !this.formValidator.validateIsEmail(mFatherEmail)) {
            $('#admission-father-email').addClass('input-validator');
        } else {
            $('#admission-father-email').removeClass('input-validator');
        }
    }

    changeMotherEmail(mMotherEmail) {
        if (this.formValidator.validateIsData(mMotherEmail) && !this.formValidator.validateIsEmail(mMotherEmail)) {
            $('#admission-mother-email').addClass('input-validator');
        } else {
            $('#admission-mother-email').removeClass('input-validator');
        }
    }

    changeAadharNumber(mStudenAadharNumber) {
        if (this.formValidator.validateIsData(mStudenAadharNumber) && !(/^[0-9]{12}$/.test(mStudenAadharNumber))) {
            $('#admission-aadhar-number').addClass('input-validator');
        } else {
            $('#admission-aadhar-number').removeClass('input-validator');
        }
    }

    changeAcademic(selectedAcademicYear) {
        if (!this.formValidator.validateDropdownData(selectedAcademicYear)) {
            $('#select-academic-year').addClass('input-validator');
        } else {
            $('#select-academic-year').removeClass('input-validator');
        }
        this.getAllStops()

    }

    changeCategory(selectedCategory) {
        if (!this.formValidator.validateDropdownData(selectedCategory)) {
            $('#admission-select-category').addClass('input-validator');
        } else {
            $('#admission-select-category').removeClass('input-validator');
        }
    }

    changeClass(selectedClassSection) {
        if (!this.formValidator.validateDropdownData(selectedClassSection)) {
            $('#add-classname').addClass('input-validator');
        } else {
            $('#add-classname').removeClass('input-validator');
        }
    }

    changeClassSection(selectedClassSectionId) {
        if (!this.formValidator.validateDropdownData(selectedClassSectionId)) {
            $('#add-clname').addClass('input-validator');
        } else {
            $('#add-clname').removeClass('input-validator');
        }
    }

    changeFatherName(mFatherName) {
        const validationMessage = this.formValidator.validateFieldName(mFatherName, "Father ");
        if (validationMessage) {
            // this.errorMessage.fatherNameErrorMsg = validationMessage
            $('#admission-father-name').addClass('input-validator');
            customToastr(validationMessage, 'error')
        } else {
            // this.errorMessage.fatherNameErrorMsg = ""
            $('#admission-father-name').removeClass('input-validator');
        }
    }

    changeFatherAdd(mFatherAddress) {
        if (!this.formValidator.validateIsData(mFatherAddress) || $.isNumeric(mFatherAddress)) {
            $('#admission-staddress').addClass('input-validator');
        } else {
            $('#admission-staddress').removeClass('input-validator');
        }
        this.mFatherAddress = mFatherAddress;
    }

    changeFatherQual(mFatherQualification) {
        if ($.isNumeric(mFatherQualification)) {
            $('#admission-edu').addClass('input-validator');
        } else {
            $('#admission-edu').removeClass('input-validator');
        }
    }

    async changeMotherName(mMotherName) {
        if ($.isNumeric(mMotherName)) {
            $('#motherName').addClass('input-validator');
            const invalidMotherNameTranslation = await firstValueFrom(this.translate.get('header.invalidMotherName')); 
            customToastr(invalidMotherNameTranslation, 'error');
        } else {
            $('#motherName').removeClass('input-validator');
        }
    }

    changeGuarName(mGuardianName) {
        if ($.isNumeric(mGuardianName)) {
            $('#guardian-name').addClass('input-validator');
        } else {
            $('#guardian-name').removeClass('input-validator');
        }
    }

    changeGuardianNum(mGuardianNumber) {
        const errorMessage = this.formValidator.validateMobileNumberForNewAdmission(this.strings.guardian, mGuardianNumber)
        if (errorMessage) {
            $('#guardian-number').addClass('input-validator');
            // customToastr(errorMessage,'error')
        } else {
            $('#guardian-number').removeClass('input-validator');
        }
    }

    changeGuardQual(mGuardianQualification) {
        if ($.isNumeric(mGuardianQualification)) {
            $('#guar-qual').addClass('input-validator');
        } else {
            $('#guar-qual').removeClass('input-validator');
        }
    }

    changeGuarAdd(mGuardianAddress) {
        if (!this.formValidator.validateIsData(mGuardianAddress) || $.isNumeric(mGuardianAddress)) {
            $('#guard-staddress').addClass('input-validator');
        } else {
            $('#guard-staddress').removeClass('input-validator');
        }
        this.mGuardianAddress = mGuardianAddress;
    }

    openBrowserToUplaodPhotoAddmission() {
        $('#openfileadmission').trigger('click');
    }


    async finishAdmissionProcess1() {
        // const admissionSuccessTranslation = await firstValueFrom(this.translate.get('header.admissionSuccess')); customToastr(admissionSuccessTranslation, 'success');
        this.mFatherNumber = this.addStudentFatherMobileNumberInput;

        this.mDOB = $('#admission-dob').val();
        this.mAdmissionDate = $('#admission-date').val();

        if (!this.formValidator.validateIsData(this.mStudentName)) {
            $('#admission-student-name').addClass('input-validator');
        }

        if (!this.formValidator.validateIsData(this.mDOB)) {
            $('#admission-dob').addClass('input-validator');
        }
        if (!this.formValidator.validateIsData(this.selectedAcademicYear)) {
            $('#select-academic-year').addClass('input-validator');
        }
        if (this.formValidator.validateIsData(this.mStudenAadharNumber) && !(/^[0-9]{12}$/.test(this.mStudenAadharNumber))) {
            $('#admission-aadhar-number').addClass('input-validator');
        }
        if (this.addNewStudentPENNumber) {
            const penNumberLength = this.addNewStudentPENNumber.length;
            if (penNumberLength < 11 || penNumberLength > 12) {
                const pleaseEnterAValidPenNumberWith11Or12DigitsTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterAValidPenNumberWith11Or12Digits')); 
                return customToastr(pleaseEnterAValidPenNumberWith11Or12DigitsTranslation, 'error');
            }
        }
        if (this.addNewFatherPinCode && this.addNewFatherPinCode.length < 6) {
            const pleaseEnterValidFatherPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterValidFatherPinCodeIsExactly6Digits')); 
            customToastr(pleaseEnterValidFatherPinCodeIsExactly6DigitsTranslation, 'error')
            return ;
        }

        if (this.addNewMotherPinCode && this.addNewMotherPinCode.length < 6) {
            const pleaseEnterValidMotherPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterValidMotherPinCodeIsExactly6Digits')); 
            customToastr(pleaseEnterValidMotherPinCodeIsExactly6DigitsTranslation, 'error');
            return ;
        }

        if (this.addNewGuardianPinCode && this.addNewGuardianPinCode.length < 6) {
            const pleaseEnterValidGuardianPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterValidGuardianPinCodeIsExactly6Digits')); 
            customToastr(pleaseEnterValidGuardianPinCodeIsExactly6DigitsTranslation, 'error');
            return ;
        }

        if (this.selectedCategory === null) {
            $('#admission-select-category').addClass('input-validator');
        }
        if (this.selectedClassSection === null) {
            $('#add-classname').addClass('input-validator');
        }
        if (this.selectedClassSectionId === null) {
            $('#add-clname').addClass('input-validator');
        }
        if (!this.formValidator.validateIsData(this.mAdmissionDate)) {
            $('#admission-date').addClass('input-validator');
        }
        if (this.mFatherName === undefined || !this.formValidator.validateIsData(this.mFatherName)) {
            $('#admission-father-name').addClass('input-validator');
        }

        this.addStudentMobileNumber = this.addStudentMobileNumberParsed
        if (this.addStudentMobileNumberParsed) {
            if (this.addStudentMobileNumberParsed && this.invalidMobileNumber) {
                const pleaseEnterValidStudentMobileNumberTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterValidStudentMobileNumber')); 
                customToastr(pleaseEnterValidStudentMobileNumberTranslation, 'error');
                return;
            }
        }

        if (!this.mFatherNumber || (this.mFatherNumber && this.invalidAddStudentFatherMobileNumber)) {
            const pleaseEnterValidFatherMobileNumberTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterValidFatherMobileNumber')); 
            customToastr(pleaseEnterValidFatherMobileNumberTranslation, 'error');
            return;
        }
        if (this.mFatherAddress === undefined || !this.formValidator.validateIsData(this.mFatherAddress)) {
            $('#admission-staddress').addClass('input-validator');
        }
        this.mMotherNumber = this.addNewStudentMotherNumberInput
        if (this.addNewStudentMotherNumberInput) {
            if (this.addNewStudentMotherNumberInput && this.invalidAddStudentMotherMobileNumber) {
                const pleaseEnterValidStudentMotherMobileNumberTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterValidStudentMotherMobileNumber')); 
                customToastr(pleaseEnterValidStudentMotherMobileNumberTranslation, 'error');
                return;
            }
        }
        if (!this.mBusId || this.mBusId === '0' || this.mBusId === '') {
            this.mBusId = 0;
        }
        if (!this.selectedBusStop || this.selectedBusStop === '0' || this.selectedBusStop === '') {
            this.selectedBusStop = 0;
        }

        this.mMotherNumber = this.addNewStudentMotherNumberInput;
        if (!this.formValidator.validateIsData(this.mStudentName)) {
            const invalidStudentNameTranslation = await firstValueFrom(this.translate.get('header.invalidStudentName')); 
            customToastr(invalidStudentNameTranslation, 'error');
        } else if (!this.formValidator.validateIsData(this.mGenderGroup)) {
            const invalidStudentGenderTranslation = await firstValueFrom(this.translate.get('header.invalidStudentGender')); 
            customToastr(invalidStudentGenderTranslation, 'error');
        } else if (!this.formValidator.validateIsData(this.mDOB)) {
            const selectStudentDobTranslation = await firstValueFrom(this.translate.get('header.selectStudentDob')); 
            customToastr(selectStudentDobTranslation, 'error');
        } else if (!this.formValidator.validateIsData(this.mBloodGroup)) {
            const bloodGroupIsNotValidTranslation = await firstValueFrom(this.translate.get('header.bloodGroupIsNotValid')); 
            customToastr(bloodGroupIsNotValidTranslation, 'error');
        } else if (!this.formValidator.validateIsData(this.mNationality)) {
            const selectStudentNationalityTranslation = await firstValueFrom(this.translate.get('header.selectStudentNationality')); 
            customToastr(selectStudentNationalityTranslation, 'error');
        } else if (!this.formValidator.validateIsData(this.admissionBase)) {
            const selectAdmissionBaseTranslation = await firstValueFrom(this.translate.get('header.selectAdmissionBase')); 
            customToastr(selectAdmissionBaseTranslation, 'error');
        } else if (this.formValidator.validateIsData(this.mStudenAadharNumber) && !(/^[0-9]{12}$/.test(this.mStudenAadharNumber))) {
            const enterValid12DigitAadharNumberTranslation = await firstValueFrom(this.translate.get('header.enterValid12DigitAadharNumber')); 
            customToastr(enterValid12DigitAadharNumberTranslation, 'error');
        } else if (this.selectedAcademicYear === '0') {
            const selectAcademicYearTranslation = await firstValueFrom(this.translate.get('header.selectAcademicYear')); 
            customToastr(selectAcademicYearTranslation, 'error');
        } else if (this.selectedCategory === null || this.selectedCategory === '0') {
            const selectClassCategoryTranslation = await firstValueFrom(this.translate.get('header.selectClassCategory')); 
            customToastr(selectClassCategoryTranslation, 'error');
        } else if (!this.formValidator.validateIsData(this.selectedClassSectionId) || this.selectedClassSectionId === '0') {
            const selectClassAndSectionTranslation = await firstValueFrom(this.translate.get('header.selectClassAndSection')); 
            customToastr(selectClassAndSectionTranslation, 'error');
        } else if (this.generateStudentRegistrationId === 'MANUAL' && !this.formValidator.validateIsData(this.mAdmissionNumber)) {
            const enterAdmissionNumberTranslation = await firstValueFrom(this.translate.get('header.enterAdmissionNumber')); 
            customToastr(enterAdmissionNumberTranslation, 'error');
        } else if (!this.formValidator.validateIsData(this.mAdmissionDate)) {
            const selectAdmissionDateTranslation = await firstValueFrom(this.translate.get('header.selectAdmissionDate')); 
            customToastr(selectAdmissionDateTranslation, 'error');
        } else if (this.mFatherName === undefined || !this.formValidator.validateIsData(this.mFatherName)) {
            const fatherNameIsMissingTranslation = await firstValueFrom(this.translate.get('header.fatherNameIsMissing')); 
            customToastr(fatherNameIsMissingTranslation, 'error');
        }
        // else if (this.mFatherNumber === undefined || validateFatherMobilenumber) {
        //   customToastr(validateFatherMobilenumber, 'error');
        // }
        else if (this.mFatherAddress === undefined || !this.formValidator.validateIsData(this.mFatherAddress)) {
            const fatherAddressIsMissingTranslation = await firstValueFrom(this.translate.get('header.fatherAddressIsMissing')); 
            customToastr(fatherAddressIsMissingTranslation, 'error');
        } else if (this.mBusId !== 0 && this.selectedBusStop !== 0 && this.selectedBusTerms.length === 0) {
            const pleaseSelectAtLeastOneTermTranslation = await firstValueFrom(this.translate.get('header.pleaseSelectAtLeastOneTerm')); 
            customToastr(pleaseSelectAtLeastOneTermTranslation, 'error');
            return;
        } else {
            this.finishedAdmission();
        }
    }

    mMotherSameFatherAddressClick() {
        if (this.mMotherSameFatherAddress === true) {
            this.mMotherAddress = this.mFatherAddress;
            this.mMotherNumber = this.mFatherNumber;
            this.addNewStudentMotherNumberInput = this.addStudentFatherMobileNumberInput;
            if (this.invalidAddStudentFatherMobileNumber) {
                this.invalidAddStudentMotherMobileNumber = true;
            } else {
                this.invalidAddStudentMotherMobileNumber = false;
            }
            this.addNewMotherPinCode = this.addNewFatherPinCode
        } else {
            this.mMotherAddress = '';
            this.mMotherNumber = '';
            this.addNewMotherPinCode = ""
        }
    }

    mGuardianSameFatherAddressClick() {
        if (this.mGuardianSameFatherAddress === true) {
            this.mGuardianAddress = this.mFatherAddress;
            this.addNewGuardianPinCode = this.addNewFatherPinCode
        } else {
            this.mGuardianAddress = '';
            this.addNewGuardianPinCode = "";
        }
    }

    async uploadStudentImageForAdmission(authToken, imageId, studentId) {
        let profilePicUpload = false;
        let aadharUpload = false;
        let tcOrBirthCopyUpload = false;
        let ewsCopyUpload = false;
        let divyangjanCopyUpload = false;
        let singleGirlChildCopyUpload = false;
        let casteCopyUpload = false;

        $('#admissionbtndisable').attr('disabled', true);
        this.translate.get('header.pleaseWait').subscribe((translatedText: string) => {
            $('#admissionbtndisable').text(translatedText);
        });
        let imageUploadTapped = false;
        const ImageUploadData = new FormData();
        const h = this;
        const imageElement = $('#' + imageId)[0];
        const aadharElement = $('#new-addmission-student-aadhar-copy')[0];
        const tcOrBirthElement = $('#new-addmission-student-tc-or-birth-copy')[0];
        const ewsElement = $('#new-addmission-student-EWS-copy')[0];
        const divyangjanElement = $('#new-addmission-student-Divyangjan-copy')[0];
        const singleGirlElement = $('#new-addmission-student-single-girl-copy')[0];
        const casteElement = $('#new-admission-student-caste-copy')[0];
        if ((imageElement?.files && imageElement.files.length > 0) ||
            (aadharElement?.files && aadharElement.files.length > 0) ||
            (tcOrBirthElement?.files && tcOrBirthElement.files.length > 0) ||
            (ewsElement?.files && ewsElement.files.length > 0) ||
            (divyangjanElement?.files && divyangjanElement.files.length > 0) ||
            (singleGirlElement?.files && singleGirlElement.files.length > 0) || (casteElement?.files && casteElement.files.length > 0)) {

            const ImageUploadData = new FormData();

            if (imageElement?.files && imageElement.files.length > 0) {
                profilePicUpload = true;
                $('#hidetxtbox').addClass('hide');
                ImageUploadData.append('image', imageElement.files[0]);
            }

            if (aadharElement?.files && aadharElement.files.length > 0) {
                aadharUpload = true;
                ImageUploadData.append('aadharReference', aadharElement.files[0]);
            }

            if (tcOrBirthElement?.files && tcOrBirthElement.files.length > 0) {
                tcOrBirthCopyUpload = true;
                ImageUploadData.append('tcOrBirthCertificate', tcOrBirthElement.files[0]);
            }

            if (ewsElement?.files && ewsElement.files.length > 0) {
                ewsCopyUpload = true;
                ImageUploadData.append('ewsCertificate', ewsElement.files[0]);
            }

            if (divyangjanElement?.files && divyangjanElement.files.length > 0) {
                divyangjanCopyUpload = true;
                ImageUploadData.append('speciallyAbled', divyangjanElement.files[0]);
            }

            if (singleGirlElement?.files && singleGirlElement.files.length > 0) {
                singleGirlChildCopyUpload = true;
                ImageUploadData.append('singleGirlChildCertificate', singleGirlElement.files[0]);
            }

            if (casteElement?.files && casteElement.files.length > 0) {
                casteCopyUpload = true;
                ImageUploadData.append('casteCertificate', casteElement.files[0]);
            }

            $('#new-student-progress-div').removeClass('hide');
            $('#new-student-admission-progress-div').removeClass('hide');
            $.ajax({
                beforeSend: request => {
                    request.setRequestHeader('enctype', 'multipart/form-data');
                    request.setRequestHeader('authToken', authToken);
                },
                url: AppSettings.API_ENDPOINT + '/upload/image?userType=STUDENT&userId=' + studentId,
                data: ImageUploadData,
                cache: false,
                processData: false,
                contentType: false,
                xhr: () => {
                    // upload Progress
                    const xhr = $.ajaxSettings.xhr();
                    if (xhr.upload) {
                        xhr.upload.addEventListener('progress', event => {
                            let percent = 0;
                            const position = event.loaded || event.position;
                            const total = event.total;
                            if (event.lengthComputable) {
                                percent = Math.ceil(position / total * 100);
                            }
                            $('#new-student-admission-percent-progress').attr('aria-valuenow', percent);
                            $('#new-student-admission-percent-progress').css({ width: percent + '%' });

                            // Update progress text based on files being uploaded
                            const uploadStatusText = [];
                            if (profilePicUpload) uploadStatusText.push('Profile pic');
                            if (aadharUpload) uploadStatusText.push('Aadhar copy');
                            if (tcOrBirthCopyUpload) uploadStatusText.push('TC or Birth certificate');
                            if (ewsCopyUpload) uploadStatusText.push('EWS certificate');
                            if (divyangjanCopyUpload) uploadStatusText.push('Specially abled certificate');
                            if (singleGirlChildCopyUpload) uploadStatusText.push('Single girl child certificate');
                            if (casteCopyUpload) uploadStatusText.push('Caste certificate');
                            this.translate.get('header.uploading').subscribe((translatedText: string) => {
                                $('#new-student-admission-percent-progress').text(uploadStatusText.join(', ') + ' '+ translatedText +' ' + percent + '%');
                            });
                            $('#new-student-admission-percent-progress').text(uploadStatusText.join(', ') + ' uploading... ' + percent + '%');

                        }, true);
                    }
                    return xhr;
                },
                type: 'POST',
                success: async (data, status, req) => {
                    $('body').find('#bus-selection-add').val('0');
                    $('body').find('#bus-stop-selection-add').val('0');
                    imageUploadTapped = true;
                    h.selectedAcademicYear = '0';
                    if (data && data.status) {
                        //  show success message
                        $('#new-student-admission-progress-div').addClass('hide');
                        const newAdmissionSuccessTranslation = await firstValueFrom(this.translate.get('header.newAdmissionSuccess')); 
                        customToastr(newAdmissionSuccessTranslation, 'success');
                        $('#close-modal').trigger('click');
                        $('.close').click();

                    } else {
                        $('#admissionbtndisable').attr('disabled', false);
                        this.translate.get('header.finish').subscribe((translatedText: string) => {
                            $('#admissionbtndisable').text(translatedText);
                        });
                        $('#new-student-admission-progress-div').addClass('hide');
                        //  show error message
                        if (profilePicUpload && aadharUpload && tcOrBirthCopyUpload && ewsCopyUpload) {
                            const profilePicAadharEwsTcOrBirthCertificateUploadFailedTranslation = await firstValueFrom(this.translate.get('header.profilePicAadharEwsTcOrBirthCertificateUploadFailed')); 
                            customToastr(profilePicAadharEwsTcOrBirthCertificateUploadFailedTranslation, 'error');
                        } else if (profilePicUpload) {
                            const profilePicUploadFailedTranslation = await firstValueFrom(this.translate.get('header.profilePicUploadFailed')); 
                            customToastr(profilePicUploadFailedTranslation, 'error');
                        } else if (aadharUpload) {
                            const aadharCopyUploadFailedTranslation = await firstValueFrom(this.translate.get('header.aadharCopyUploadFailed')); 
                            customToastr(aadharCopyUploadFailedTranslation, 'error');
                        } else if (tcOrBirthCopyUpload) {
                            const tcOrBirthCertificateUploadFailedTranslation = await firstValueFrom(this.translate.get('header.tcOrBirthCertificateUploadFailed')); 
                            customToastr(tcOrBirthCertificateUploadFailedTranslation, 'error');
                        }
                        else if (ewsCopyUpload) {
                            const tcOrBirthCertificateUploadFailedTranslation = await firstValueFrom(this.translate.get('header.tcOrBirthCertificateUploadFailed')); 
                            customToastr(tcOrBirthCertificateUploadFailedTranslation, 'error');
                        } else if (divyangjanCopyUpload) {
                            const speciallyAbledCertificateUploadFailedTranslation = await firstValueFrom(this.translate.get('header.speciallyAbledCertificateUploadFailed')); 
                            customToastr(speciallyAbledCertificateUploadFailedTranslation, 'error');
                        }
                        else if (singleGirlChildCopyUpload) {
                           const singleGirlChildCertificateUploadFailedTranslation = await firstValueFrom(this.translate.get('header.singleGirlChildCertificateUploadFailed')); 
                           customToastr(singleGirlChildCertificateUploadFailedTranslation, 'error');
                        }

                    }
                    this.profileImageSelected = false;
                },
                error: async (req, status, error) => {
                    h.selectedAcademicYear = '0';
                    $('#hide-txt-foradmsn').removeClass('hide');
                    if (profilePicUpload && aadharUpload && tcOrBirthCopyUpload && ewsCopyUpload) {
                        const profilePicAadharCopyAndTcOrBirthCertificateUploadFailedTranslation = await firstValueFrom(this.translate.get('header.profilePicAadharCopyAndTcOrBirthCertificateUploadFailed')); 
                        customToastr(profilePicAadharCopyAndTcOrBirthCertificateUploadFailedTranslation, 'error');
                    } else if (profilePicUpload) {
                        const profilePicUploadFailedTranslation = await firstValueFrom(this.translate.get('header.profilePicUploadFailed')); 
                        customToastr(profilePicUploadFailedTranslation, 'error');
                    } else if (aadharUpload) {
                        const aadharCopyUploadFailedTranslation = await firstValueFrom(this.translate.get('header.aadharCopyUploadFailed')); 
                        customToastr(aadharCopyUploadFailedTranslation, 'error');
                    } else if (tcOrBirthCopyUpload) {
                       const tcOrBirthCertificateUploadFailedTranslation = await firstValueFrom(this.translate.get('header.tcOrBirthCertificateUploadFailed')); 
                       customToastr(tcOrBirthCertificateUploadFailedTranslation, 'error');
                    }
                    else if (ewsCopyUpload) {
                        const ewsCertificateUploadFailedTranslation = await firstValueFrom(this.translate.get('header.ewsCertificateUploadFailed')); 
                        customToastr(ewsCertificateUploadFailedTranslation, 'error');
                    } else if (divyangjanCopyUpload) {
                       const speciallyAbledCertificateUploadFailedTranslation = await firstValueFrom(this.translate.get('header.speciallyAbledCertificateUploadFailed')); 
                       customToastr(speciallyAbledCertificateUploadFailedTranslation, 'error');
                    } else if (singleGirlChildCopyUpload) {
                        const singleGirlChildCertificateUploadFailedTranslation = await firstValueFrom(this.translate.get('header.singleGirlChildCertificateUploadFailed')); 
                        customToastr(singleGirlChildCertificateUploadFailedTranslation, 'error');
                    }
                    imageUploadTapped = true;
                    //  show error message
                    $('#admissionbtndisable').attr('disabled', false);
                    this.translate.get('header.finish').subscribe((translatedText: string) => {
                        $('#admissionbtndisable').text(translatedText);
                    });

                    this.profileImageSelected = false;
                }
            });
        } else {
            $('#admissionbtndisable').attr('disabled', true);
            this.translate.get('header.pleaseWait').subscribe((translatedText: string) => {
                $('#admissionbtndisable').text(translatedText);
            });
            const newAdmissionSuccessTranslation = await firstValueFrom(this.translate.get('header.newAdmissionSuccess')); 
            customToastr(newAdmissionSuccessTranslation, 'success');
            $('#close-modal').trigger('click');
            this.newAdmissionDataClear();
            $('.close').click();
            $('body').find('#bus-selection-add').val('0');
            $('body').find('#bus-stop-selection-add').val('0');
            this.selectedAcademicYear = '0';
        }
    }
    initScripts() {
        this.scriptLoader.loadScript($, 'DASHBOARD');
    }

    async ngOnInit() {
        /* header-v2 sits outside the router-outlet and is never destroyed
           on navigation, but groups.component only hides these floating
           ID-card/TC buttons when the user manually deselects students
           there. Force them hidden on every route change away from groups
           so they don't stay visible on unrelated pages. */
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            if (!event.urlAfterRedirects.includes('/groups')) {
                $('#id-print-floating-button').hide();
                $('#id-print-floating-button-staff').hide();
            }
        });

        /* #class-config-popup's markup/data (classConfigList etc.) lives on
           this component, but the button that opens it now lives on
           HeaderV3Component (this component's own bar is hidden — see
           layout.component.html/styles.css), which has no access to this
           component's instance/methods. Binding to Bootstrap's own
           show.bs.modal event (fired regardless of which element
           triggered the data-toggle="modal" open) means the fetch runs no
           matter which header is the one actually clicked.
           Bound on `document` with a selector filter (event delegation),
           NOT $('#class-config-popup').on(...) directly — ngOnInit can run
           before this component's own template (and therefore the modal
           element) has actually been painted into the DOM, in which case
           a direct selector-based .on() silently attaches to an empty
           jQuery selection and never fires. Delegation only needs the
           element to exist at EVENT time, not at bind time. */
        $(document).on('show.bs.modal', '#class-config-popup', () => {
            this.getClassConfigStatusList();
        });

        /* Same cookie/localStorage race as usertoken/schoolinfo below —
           the active login flow only ever writes loginMode to a cookie, so
           this needs the same fallback or *ngIf="loginMode == 'WEB_ADMIN'"
           checks (e.g. the New Admission button) fail right after login and
           only pass after a refresh. */
        this.loginMode = localStorage.getItem('loginMode');
        if (!this.loginMode) {
            const cookieLoginMode = this.getCookieValue('loginMode');
            if (cookieLoginMode) {
                this.loginMode = cookieLoginMode;
                localStorage.setItem('loginMode', cookieLoginMode);
            }
        }
        this.currType = localStorage.getItem('currency') || 'INR';
        // The brand's default country always wins here, regardless of any
        // school-specific countryCode saved in localStorage — the country
        // picker should reflect the active brand/domain, not a previously-
        // saved school record.
        this.countryCode = this.brand.defaultCountryDialCode || localStorage.getItem('countryCode') || '91';

        this.initScripts();
        localStorage.removeItem('current_academic');

        /* The active login flow only ever writes usertoken/schoolinfo to
           cookies, never to localStorage — localStorage only gets backfilled
           later, inside the dashboard component's own init. Since the header
           and the dashboard mount at the same time, reading only localStorage
           here races that backfill: isValidToken() below silently no-ops
           when getSchoolId is empty, so the school name / header details
           never load until a refresh re-derives them. Fall back to the
           cookie and backfill localStorage so this works on first render. */
        this.getAuthToken = localStorage.getItem('usertoken');
        if (!this.getAuthToken) {
            const cookieToken = this.getCookieValue('usertoken');
            if (cookieToken) {
                this.getAuthToken = cookieToken;
                localStorage.setItem('usertoken', cookieToken);
            }
        }
        this.getSchoolId = localStorage.getItem('schoolinfo');
        if (!this.getSchoolId) {
            const cookieSchoolId = this.getCookieValue('schoolinfo');
            if (cookieSchoolId) {
                this.getSchoolId = cookieSchoolId;
                localStorage.setItem('schoolinfo', cookieSchoolId);
            }
        }
        let isFranchiseValue = localStorage.getItem('isFranchise');
        if (!isFranchiseValue) {
            const cookieIsFranchise = this.getCookieValue('isFranchise');
            if (cookieIsFranchise) {
                isFranchiseValue = cookieIsFranchise;
                localStorage.setItem('isFranchise', cookieIsFranchise);
            }
        }
        this.isFranchise = parseInt(isFranchiseValue);
        this.fkFranchiseId = localStorage.getItem('fkFranchiseId');
        this.currentSchoolId = this.getSchoolId;
        this.staffName = localStorage.getItem('staffName');

        /* Same first-login race as usertoken/schoolinfo above: menu.component
           derives idCardService/transferCertificate/staffIdCardService from
           the extensionServices cookie and writes them to localStorage, but
           header-v2 mounts alongside menu and can read these flags before
           that write happens. Re-derive them here from extensionServices
           directly so the floating TC/ID-card buttons don't need a refresh. */
        if (!localStorage.getItem('idCardService') && !localStorage.getItem('transferCertificate') && !localStorage.getItem('staffIdCardService')) {
            let extensionServicesRaw = localStorage.getItem('extensionServices') || this.getCookieValue('extensionServices');
            if (extensionServicesRaw) {
                try {
                    const servicesArray = JSON.parse(extensionServicesRaw);
                    if (servicesArray && servicesArray.length > 0) {
                        for (const service of servicesArray) {
                            if (service.serviceName === 'TRANSFER_CERTIFICATE') {
                                this.transferCertificateEnables = service.serviceStatus === 'ENABLED' ? 'true' : 'false';
                            }
                            if (service.serviceName === 'ID_CARD') {
                                this.idCardServiceEnables = service.serviceStatus === 'ENABLED' ? 'true' : 'false';
                            }
                            if (service.serviceName === 'STAFF_ID_CARD') {
                                this.staffIdCardServiceEnables = service.serviceStatus === 'ENABLED' ? 'true' : 'false';
                            }
                        }
                    }
                } catch (error) {
                }
            }
        }
        // if (this.getSchoolId === '56') {
        //     this.mCountryCode = '254';
        // }

        let profileImageSelected = false;
        const h = this;
        const currentTime = new Date();
        this.currentYear = currentTime.getFullYear();

        let adminPermissionlist = localStorage.getItem('adminPermissionlist');
        if (!adminPermissionlist) {
            const cookiePermissionlist = this.getCookieValue('adminPermissionlist');
            if (cookiePermissionlist) {
                adminPermissionlist = cookiePermissionlist;
                localStorage.setItem('adminPermissionlist', cookiePermissionlist);
            }
        }
        if (adminPermissionlist) {
            const list = JSON.parse(adminPermissionlist);
            this.permissions = list;
        }
        this.isValidToken();

        $('#accountStatusDeActive').click(() => {
            $('#reason').show();
        });
        $('#accountStatusActive').click(() => {
            $('#reason').hide();
        });
        $('#accstatus2').click(() => {
            $('#reasonStaff').show();
        });
        $('#accstatus').click(() => {
            $('#reasonStaff').hide();
        });
        this.getAllStops();
        this.getSchoolHouseListDetails()
        $('#admission-dob').change(function () {
            h.mDOB = $(this).val();
            const validateMessage = h.formValidator.valdateDOB(h.mDOB)
            if (validateMessage) {
                // h.mDOB = null;
                // $('#admission-dob').addClass('input-valinulldator');
                customToastr(validateMessage, 'error')
                $('#admission-dob').addClass('input-validator');
            } else {
                $('#admission-dob').removeClass('input-validator');
                $(this).datepicker('hide');
            }
        });

        $('#admission-date').change(async function () {
            h.mAdmissionDate = $(this).val();
            if (h.formValidator.validateIsDataForString(h.mAdmissionDate)) {
                // h.mDOB = null;
                const studentDOB = new Date(h.mDOB);
                const studentAdmissionDate = new Date(h.mAdmissionDate);
                if (studentAdmissionDate <= studentDOB) {
                    $('#admission-date').addClass('input-validator');
                    const admissionDateShouldBeAfterStudentDateOfBirthTranslation = await firstValueFrom(h.translate.get('admissionDateShouldBeAfterStudentDateOfBirth')); 
                    customToastr(admissionDateShouldBeAfterStudentDateOfBirthTranslation, 'error');
                } else {
                    $('#admission-date').removeClass('input-validator');
                    $(this).datepicker('hide');
                }
            } else {
                $('#admission-date').removeClass('input-validator');
                $(this).datepicker('hide');
            }
        });

        $('#id-print-floating-button').hide();
        $('#id-print-floating-button-staff').hide();
        $('.after').append('<script>function customToastr(message,type,showDuration){toastr.options.hideDuration = 0;toastr.clear();' +
            'toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;' +
            'toastr.options.positionClass = \'toast-top-right\';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;' +
            'toastr.options.timeOut = showDuration || 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = \'swing\';' +
            'toastr.options.hideEasing = \'swing\';toastr.options.showMethod = \'slideDown\';toastr.options.hideMethod = \'slideUp\';' +
            'toastr[type](message, \'\');return 0;} </' + 'script>');


        $('#openfileadmission').change(async function () {


            $('#hide-txt-foradmsn').removeClass('hide');
            $('#studentadmsson-progressbar').addClass('hide');

            const extension = $(this).val().split('.').pop().toLowerCase();
            const ExtListToUpload = new Array('gif', 'jpeg', 'png', 'jpg');
            const isValidFileExt = $.inArray(extension, ExtListToUpload);
            if (isValidFileExt === -1) {
                profileImageSelected = false;
                $(this).replaceWith($(this).val('').clone(true));
                $('#hide-txt-foradmsn').removeClass('hide');
                $('#studentadmsson-progressbar').addClass('hide');
                const pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation = await firstValueFrom(this.translate.get('header.pleaseSelectAValidImageTypeOfGifJpegPngJpg')); 
                customToastr(pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation, 'error');
            } else {
                profileImageSelected = false;
                if ($(this).get(0).files[0].size > (1024 * 1024 * 20)) {
                    $(this).replaceWith($(this).val('').clone(true));
                    $('#hide-txt-foradmsn').removeClass('hide');
                    $('#studentadmsson-progressbar').addClass('hide');
                    const imageSizeShouldNotExceed20MbTranslation = await firstValueFrom(this.translate.get('header.imageSizeShouldNotExceed20Mb')); 
                    customToastr(imageSizeShouldNotExceed20MbTranslation, 'error');
                } else {
                    profileImageSelected = true;
                    if (this.files && this.files[0]) {
                        const reader = new FileReader();
                        reader.onload = imageIsLoadedForAdmission;
                        reader.readAsDataURL(this.files[0]);
                    }
                    /*h.uploadStudentImage("openbrowser",new Date().getMilliseconds());*/
                }
            }
        });

        function imageIsLoadedForAdmission(e) {
            $('#studentimageadmission').attr('src', e.target.result);
        }

        $('#print-id-form').on('click', () => {

            $('.hide-while-print').hide();

            const DocumentContainer = document.getElementById('id-receipt-print-container');
            const name = 'ID_CARD';

            const WindowObject =
                window.open(name, 'Receipt', 'width=1500,height=1100,top=100,left=150,toolbars=no,scrollbars=yes,status=no,resizable=no');
            WindowObject.document.writeln(DocumentContainer.innerHTML);

            WindowObject.document.close();
            WindowObject.focus();
            WindowObject.open();
            WindowObject.print();
            $('.hide-while-print').show();
            $('#clear-selected-students').trigger('click');
        });

        function imageIsLoadedForEditStudent(e) {
            $('#editstudentimage').attr('src', e.target.result);
        }

        this.translate.onLangChange.subscribe(() => {
            this.updatePercentageText();
        });
    }

    logout() {
        this.logoutUser();
            //   localStorage.clear();
            //     this.deleteCookiesBasedOnURL();
            //     this.router.navigate(['/login']);
    }

    async logoutUser() {
        try {
            const response = await firstValueFrom(this.headerservice.logoutUser());
            const data = response as any;
            if (data?.status) {
                for (const key in localStorage) {
                    if (key !== 'lang') {
                        localStorage.removeItem(key);
                    }
                }
                this.deleteCookiesBasedOnURL();
                this.router.navigate(['/login']);
                   const logoutSuccessfullyTranslation = await firstValueFrom(this.translate.get('header.logoutSuccessfully')); 
                   customToastr(logoutSuccessfullyTranslation, 'success');
            } else {
                const failedToLogoutPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('header.failedToLogoutPleaseTryAgain')); 
                customToastr(failedToLogoutPleaseTryAgainTranslation, 'error');
                return;
            }
        } catch (error) {
            const oppsSomethingWentWrongTranslations = await firstValueFrom(this.translate.get('header.oppsSomethingWentWrong'));
            customToastr(oppsSomethingWentWrongTranslations)
        }
    }

    deleteCookiesBasedOnURL() {
        if (window.location.hostname.split('.')[1] === 'localhost') {
            this.commonFunction.deleteAllLocalCookies();
        } else {
            this.commonFunction.deleteAllCookies();
        }
    }

    getSchoolHouseListDetails() {
        console.log("getSchoolHouseListDetails ::",localStorage.getItem('usertoken'));
        
        this.groupservice.getSchoolHouseList(localStorage.getItem('usertoken')).subscribe(
            (data: any) => {
                if (data.status) {
                    this.houseNameList = JSON.parse(JSON.stringify(data.list));
                }
                else {
                    this.houseNameList = [];
                }
            },
            error => {
                console.error(error)
            }
        );
    }

    getCurrentAcademic(schoolId) {
        this.groupservice.groupsStudentAcademicList(schoolId, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    for (const item of data.academicList) {
                        if (item.InActive === 0) {
                            this.academicId = item.pkAcademicId;
                            this.schoolAcademicCurrentYear = item.Year;
                        }
                    }
                },
                error => {
                }
            );
    }

    getAllStops() {
        this.transportservice.fetchBusStop(this.selectedAcademicYear, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    this.busStopListData = data;

                },
                error => {
                }
            );
    }

    getAllBusRoutes(schoolId) {
        this.transportservice.getAllBuses(schoolId, this.selectedAcademicYear, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    this.busListData = data;
                },
                error => {
                }
            );
    }

    getStopsOfRoute(schoolId, classId) {
        this.transportservice.getstopsOfRoute(schoolId, classId, this.selectedAcademicYear, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    this.busStopListData = data;
                },
                error => {
                }
            );
    }

    async getAllAcademicYears() {
        try {
            this.selectedAcademicYear = '0';
            const response = await firstValueFrom(this.admissionservice.getAcademicList());
            const responseDetails = response as any;
            if (responseDetails && responseDetails.body && responseDetails.body.length > 0) {
                this.academicYearsList = responseDetails.body;
                this.selectedAcademicYearObj = responseDetails.body;
            } else {
                customToastr(responseDetails.error.message);
            }
        } catch (error) {
            customToastr(
                error
                    ? error.error
                        ? error.error.message
                        : this.strings.errorMessage
                    : this.strings.errorMessage,
                this.strings.errorCode
            );
        }

    }

    getAllCategories() {
        this.admissionservice.getAllCategories(this.currentSchoolId, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    this.categoryList = data;
                },
                error => {
                }
            );
    }

    fetchCategoryDetails(categoryId) {
        this.admissionservice.getCategoryDetailsFromCategoryId(this.currentSchoolId, categoryId, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    if (data !== undefined && data !== null && data.className !== undefined && data.className.length > 0) {
                        this.classSectionList = data.className;
                    }
                },
                error => {
                }
            );
    }

    fetchClassSectionOnClassId(classId) {
        this.admissionservice.getClassDetailsFromClassId(classId, localStorage.getItem('usertoken'))
            .subscribe((data: any) => {
                if (data !== undefined && data !== null && data.length > 0) {
                    this.classSections = data;
                }

            },
                error => {
                }
            );
    }


    fetchFeeComponentOfClass(classId) {
        this.feesComponentsList = [];
        this.admissionservice.getFeeComponentsOfClass(this.currentSchoolId, this.academicId, classId, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    if (data !== null && data !== undefined && data.length > 0) {
                        this.feesComponentsList = data;
                        this.calculateTotalFees();
                    }

                },
                error => {
                }
            );
    }

    showAddAmount(feesTypeId, position) {
        $('.showaddamount_' + feesTypeId).hide();
        $('.showapplyamount_' + feesTypeId).show();
    }

    applyAmount(feesTypeId, position) {
        $('.showaddamount_' + feesTypeId).show();
        $('.showapplyamount_' + feesTypeId).hide();
        let amount = $('.feesamount_' + feesTypeId).val();
        if (amount !== null && amount !== undefined && amount !== '') {
            try {
                amount = parseInt(amount, 10);
                const feesData = this.feesComponentsList;
                feesData[position].Amount = amount;
                this.feesComponentsList = feesData;
                this.calculateTotalFees();
                this.applyFeesAmountForTerm(feesTypeId, amount, position);
            } catch (err) {
            }
        }
    }

    applyFeesAmountForTerm(feesTypeId, amount, position) {
        this.admissionservice.applyFeesAmountForTerm(this.currentSchoolId, this.academicId, this.selectedClassSection,
            feesTypeId, amount, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    if (data !== undefined && data !== null && data.status !== undefined) {
                        if (data.status === false) {
                            delete this.feesComponentsList[position].Amount;
                        } else {
                        }
                    } else {
                        delete this.feesComponentsList[position].Amount;
                    }
                    this.calculateTotalFees();
                },
                error => {
                    delete this.feesComponentsList[position].Amount;
                    this.calculateTotalFees();
                }
            );
    }

    addFeesComponent() {
        const selectedAssignee = $('#fees-comp-assigned').find(':selected').text();
        this.mFeesComponentDue = $('#fees-comp-due').val();
        const feesObj = {
            Name: this.mFeesComponentName,
            includeInTerm: 0,
            academicId: this.academicId,
            AppliesTo: selectedAssignee,
            duedate: this.mFeesComponentDue,
            amount: this.mFeesComponentAmount,
            classId: this.selectedClassSection,
            schoolId: this.currentSchoolId
        };
        const updateInfo = {
            Name: feesObj.Name,
            Amount: this.mFeesComponentAmount,
            pkFeesTypeId: -100
        };
        this.feesComponentsList.push(updateInfo);

        this.admissionservice.createFeesComponent(feesObj, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    if (data.status !== undefined && data.status === true) {
                        this.feesComponentsList[this.feesComponentsList.length - 1].pkFeesTypeId = data.data.pkFeesTypeId;
                    }
                },
                error => {
                }
            );
        $('#newcomponent .close').click();

    }

    calculateTotalFees() {
        this.feesAmount = 0;
        for (const item of this.feesComponentsList) {
            if (item.Amount !== undefined) {
                this.feesAmount += item.Amount;
            }
        }
        this.mTotalFees = '' + this.feesAmount;
    }

    iterateFareOfBus(stopNumber) {
        for (const item of this.busStopListData) {
            if (item.StopNumber === stopNumber) {
                this.mTotalBusFees = 'Rs ' + item.fare;
                break;
            }
        }
    }

    iterateBusId(routeId) {
        for (const item of this.busListData) {
            if (item.pkRouteId === routeId) {
                this.mBusId = item.pkBusId;
                break;
            }
        }
    }


    callImageUploadTxt() {
        this.getLastRegNumber();
        this.getStudentCategoryList();
        this.getAllAcademicYears()
        this.getAllStops();
        this.getAllAvailableStopTerms();
        $('#studentadmsson-progressbar').addClass('hide');
        $('#hide-txt-foradmsn').removeClass('hide');
        this.newAdmissionDataClear();
        $('#admissionbtndisable').attr('disabled', false);
        this.translate.get('header.finish').subscribe((translatedText: string) => {
            $('#admissionbtndisable').text(translatedText);
        });
        this.mobileNumbersValidation()
        this.clearMobileNumberValues()
    }

    async finishedAdmission() {
        let isSingleGirlChild;
        if (this.mGenderGroup === '0') {
            isSingleGirlChild = this.addNewStudentIsSingleGirlChild === true ? 1 : 0;
        } else {
            this.addNewStudentIsSingleGirlChild = false
            isSingleGirlChild = 0;
        }
        let addNewStudentIsEWSInput;
        if (this.mCast === 'General') {
            addNewStudentIsEWSInput = this.addNewStudentIsEWS === true ? 1 : 0
        } else {
            this.addNewStudentIsEWS = false;
            addNewStudentIsEWSInput = 0;
        }
        this.mMotherOccupation = $('#admission-mother-occupation').find(':selected').text();
        this.mAdmissionBase = $('#admission-base').find(':selected').text();
        this.mAdmissionStream = $('#admission-stream').val();
        this.mDOB = $('#admission-dob').val();
        this.mAdmissionDate = $('#admission-date').val();
        this.mGuardianOccupation = $('#admission-guardian-occupation').find(':selected').text();
        this.mFatherOccupation = $('#admission-father-occupation').val();
        this.mBloodGroup = $('#admission-blood-group').find(':selected').text();
        this.mReligion = $('#admission-religion').find(':selected').text();

        if (this.mAdmissionStream === 'general') {
            this.mAdmissionStream = null;
        }

        let busId = $('body').find('#bus-selection-add').val();
        let stopId = $('body').find('#bus-stop-selection-add').val();

        if (!this.formValidator.validateIsDataForNumber(busId) || busId === 0 || busId === '0') {
            busId = null;
        }

        if (!this.formValidator.validateIsDataForNumber(stopId) || stopId === 0 || stopId === '0') {
            stopId = null;
        }

        if (stopId && !busId) {
            const pleaseSelectBusAlsoTranslation = await firstValueFrom(this.translate.get('header.pleaseSelectBusAlso')); 
            customToastr(pleaseSelectBusAlsoTranslation, 'error');
            return;
        }
        if (stopId && busId && this.selectedBusTerms.length === 0) {
            const pleaseSelectAtLeastOneTermTranslation = await firstValueFrom(this.translate.get('header.pleaseSelectAtLeastOneTerm')); 
            customToastr(pleaseSelectAtLeastOneTermTranslation, 'error');
            return;
        }
        if (!this.formValidator.validateIsData(this.mMotherName)) {
            this.mMotherName = null;
        } else if ($.isNumeric(this.mMotherName)) {
            const pleaseEnterAValidMotherNameTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterAValidMotherName')); 
            customToastr(pleaseEnterAValidMotherNameTranslation, 'error');
            return;
        }
        // const validateMobilenumber = this.formValidator.validateMobileNumberForNewAdmission(this.strings.mother, this.mMotherNumber)
        // if (!this.formValidator.validateIsDataForNumber(this.mMotherNumber)) {
        //   this.mMotherNumber = null;
        // } else if (validateMobilenumber) {
        //   customToastr(validateMobilenumber, 'error');
        //   return;
        // }
        if (!this.formValidator.validateIsDataForNumber(this.mMotherAddress)) {
            this.mMotherAddress = null;
        }


        if (!this.formValidator.validateIsData(this.mGuardianName)) {
            this.mGuardianName = null;
        } else if ($.isNumeric(this.mGuardianName)) {
            const pleaseEnterAValidGuardianNameTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterAValidGuardianName')); 
            customToastr(pleaseEnterAValidGuardianNameTranslation, 'error');
            return;
        }
        this.mGuardianNumber = this.addNewStudentGuardianNumberInput
        if (this.addNewStudentGuardianNumberInput) {
            if (this.addNewStudentGuardianNumberInput && this.invalidAddStudentGuardianMobileNumber) {
                const pleaseEnterValidGuardianMobileNumberTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterValidGuardianMobileNumber')); 
                customToastr(pleaseEnterValidGuardianMobileNumberTranslation, 'error');
                return;
            }
        }
        if (!this.formValidator.validateIsData(this.mGuardianAddress)) {
            this.mGuardianAddress = null;
        }

        let houseName = $('#admission-student-housename').val();
        if (houseName === 'None' || houseName === '' || !houseName) {
            houseName = null;
        }

        this.mFatherEmail = this.formValidator.validateIsData(this.mFatherEmail) ? this.mFatherEmail.trim() : null;
        if (this.mFatherEmail &&
            this.formValidator.validateIsData(this.mFatherEmail) &&
            !this.formValidator.validateIsEmail(this.mFatherEmail)) {
            $('#admission-father-email').addClass('input-validator');
            const pleaseEnterValidFatherEmailTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterValidFatherEmail')); 
            customToastr(pleaseEnterValidFatherEmailTranslation, 'error');
            return;
        }

        this.mMotherEmail = this.formValidator.validateIsData(this.mMotherEmail) ? this.mMotherEmail.trim() : null;
        if (
            this.formValidator.validateIsData(this.mMotherEmail) &&
            !this.formValidator.validateIsEmail(this.mMotherEmail)) {
            $('#admission-mother-email').addClass('input-validator');
            const pleaseEnterValidMotherEmailTranslation = await firstValueFrom(this.translate.get('header.pleaseEnterValidMotherEmail')); 
            customToastr(pleaseEnterValidMotherEmailTranslation, 'error');
            return;
        }

        const admissionObj = {
            houseName,
            schoolId: this.currentSchoolId,
            registrationId: null,
            studentName: this.mStudentName,
            classId: this.selectedClassSectionId,
            parentName: this.mFatherName,
            studentEmail: this.mStudentEmail,
            emailId: this.mFatherEmail,
            dateOfBirth: this.mDOB,
            mobileNumber: this.mFatherNumber,
            mobileCode: this.mCountryCode,
            motherCountryCode: this.motherCountryCode,
            guardianCountryCode: this.guardianCountryCode,
            studentCountryCode: this.studentCountryCode,
            dateOfAdmission: this.mAdmissionDate,
            address: this.mFatherAddress,
            fkAcademicId: this.selectedAcademicYearObj,
            academicId: this.selectedAcademicYearObj,
            surname: this.mSurName,
            bloodGroup: this.mBloodGroup,
            religion: this.mReligion,
            cast: this.mCast,
            nationality: this.mNationality,
            studentPhone: this.addStudentMobileNumber,
            fatherOccupation: this.mFatherOccupation,
            fatherQualification: this.mFatherQualification,
            fatherEmail: this.mFatherEmail,
            motherName: this.mMotherName,
            motherPhone: this.mMotherNumber,
            motherOccupation: this.mMotherOccupation,
            motherQualification: this.mMotherQualification,
            motherEmail: this.mMotherEmail,
            motherAddress: this.mMotherAddress,
            guardianName: this.mGuardianName,
            guardianPhone: this.mGuardianNumber,
            guardianOccupation: this.mGuardianOccupation,
            guardianQualification: this.mGuardianQualification,
            guardianAddress: this.mGuardianAddress,
            guardianEmail: this.mGuardianEmail,
            gender: this.mGenderGroup,
            admissionBase: this.mAdmissionBase,
            admissionStream: this.mAdmissionStream,
            studentImage: 'https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png',
            stopId,
            busId,
            busTerms: this.selectedBusTerms,
            aadharNumber: (!this.mStudenAadharNumber && this.mStudenAadharNumber === '') ? null : this.mStudenAadharNumber,
            penNumber: this.addNewStudentPENNumber,
            isMinority: this.addNewIsMinority === true ? 1 : 0,
            fatherPinCode: this.addNewFatherPinCode,
            motherAnnualIncome: this.addNewStudentMotherAnnualIncome,
            fatherAnnualIncome: this.addNewStudentFatherAnnualIncome,
            isSingleGirlChild: isSingleGirlChild,
            isEWSCategory: addNewStudentIsEWSInput,
            isSpeciallyAbled: this.addNewStudentIsSpeciallyDisabled === true ? 1 : 0,
            motherPinCode: this.addNewMotherPinCode,
            guardianPinCode: this.addNewGuardianPinCode,
            guardianAnnualIncome: this.addNewStudentGuardianAnnualIncome
        };
        console.log('admissionObj::: ', admissionObj);


        if (this.generateStudentRegistrationId === 'MANUAL') {
            admissionObj.registrationId = this.mAdmissionNumber;
        }

        this.callNewAdmissionService(admissionObj);
    }

    newAdmissionDataClear() {
        this.currentSchoolId = '';
        this.mAdmissionNumber = '';
        this.mStudentName = '';
        this.selectedClassSectionId = '';
        this.mFatherName = '';
        this.mStudentEmail = '';
        this.mFatherEmail = null;
        this.mDOB = '';
        this.mFatherNumber = '';
        this.mStudenAadharNumber = '';
        this.mAdmissionDate = '';
        this.mFatherAddress = '';
        this.selectedAcademicYearObj = '';
        this.selectedAcademicYearObj = '';
        this.mSurName = '';
        this.mBloodGroup = 'A+';
        this.mReligion = 'Hindu';
        this.mCast = 'General';
        this.mNationality = 'Indian';
        this.mCountryCodeFather = this.brand.defaultCountryDialCode || '91';
        this.mCountryCodeMother = this.brand.defaultCountryDialCode || '91';
        this.mCountryCodeGuardian = this.brand.defaultCountryDialCode || '91';
        this.mStudenNumber = '';
        this.mFatherOccupation = '';
        this.mFatherQualification = '';
        this.mFatherEmail = null;
        this.mMotherName = '';
        this.mMotherNumber = '';
        this.mMotherOccupation = '';
        this.mMotherQualification = '';
        this.mMotherEmail = null;
        this.mMotherAddress = '';
        this.mGuardianName = '';
        this.mGuardianNumber = '';
        this.mGuardianOccupation = '';
        this.mGuardianQualification = '';
        this.mGuardianEmail = '';
        this.mGuardianAddress = '';
        this.mGenderGroup = '1';
        this.mAdmissionBase = '';
        this.mAdmissionStream = 'general';
        this.addNewStudentPENNumber = ""
        this.addNewFatherPinCode = ""
        this.addNewStudentFatherAnnualIncome = ""
        this.addNewStudentMotherAnnualIncome = ""
        this.addNewIsMinority = false
        this.addNewStudentIsSpeciallyDisabled = false
        this.addNewStudentIsSingleGirlChild = false
        this.addNewStudentIsEWS = false;
        this.addNewGuardianPinCode = "";
        this.addNewMotherPinCode = "";
        this.addNewStudentGuardianAnnualIncome = "";
        this.mMotherSameFatherAddress = false;
        this.mGuardianSameFatherAddress = false;
        /*studentImage: "/image/placeholder.png",*/
        $('#studentimageadmission')
            .attr('src', 'https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png');
        this.selectedBusStop = 0;
        this.mBusId = 0;
        this.selectedBusTerms = [];
        $('#new-addmission-student-aadhar-image-ele').addClass('hide');
        $('#new-student-admission-progress-div').addClass('hide');
        this.translate.get('header.upload').subscribe((translatedText: string) => {
            $('#new-addmission-student-aadhar-copy-button').text(translatedText);
        });
        $('#new-addmission-student-aadhar-copy').val('');
        $('#openfileadmission').val('');
        $('#admission-student-name').removeClass('input-validator');
        $('#admission-surname').removeClass('input-validator');
        $('#admission-dob').removeClass('input-validator');

        $('#new-addmission-student-tc-or-birth-image-ele').addClass('hide');
        this.translate.get('header.upload').subscribe((translatedText: string) => {
            $('#new-addmission-student-tc-or-birth-copy-button').text(translatedText);
        });
        $('#new-addmission-student-tc-or-birth-copy').val('');

        $('#new-addmission-student-Divyangjan-image-ele').addClass('hide');
        this.translate.get('header.upload').subscribe((translatedText: string) => {
            $('#new-addmission-student-Divyangjan-copy-button').text(translatedText);
        });
        $('#new-addmission-student-Divyangjan-copy').val('');

        $('#new-addmission-student-single-girl-image-ele').addClass('hide');
        this.translate.get('header.upload').subscribe((translatedText: string) => {
            $('#new-addmission-student-single-girl-copy-button').text(translatedText);
        });
        $('#new-addmission-student-single-girl-copy').val('');

        $('#new-addmission-student-EWS-image-ele').addClass('hide');
        this.translate.get('header.upload').subscribe((translatedText: string) => {
            $('#new-addmission-student-EWS-copy-button').text(translatedText);
        });
        $('#new-addmission-student-EWS-copy').val('');

        $('#new-admission-student-caste-image-ele').addClass('hide');
        this.translate.get('header.upload').subscribe((translatedText: string) => {
            $('#new-admission-student-caste-copy-button').text(translatedText);
        });
        $('#new-admission-student-caste-copy').val('');

    }


    callNewAdmissionService(admissionObj) {
        // admissionObj.studentImage='/images/placeholder.png';

        $('#admissionbtndisable').attr('disabled', true);
        this.translate.get('header.pleaseWait').subscribe((translatedText: string) => {$('#admissionbtndisable').text(translatedText);});
        this.admissionservice.createNewAdmission(admissionObj, localStorage.getItem('usertoken'))
            .subscribe(
                async (data: any) => {
                    // callback(data);
                    // TODO: Check Status & show status message
                    if (data.status === true) {

                        this.uploadStudentImageForAdmission(localStorage.getItem('usertoken'), 'openfileadmission', data.studentId);

                    } else if (data.message) {

                        $('body').find('#bus-selection-add').val('0');
                        $('body').find('#bus-stop-selection-add').val('0');
                        $('#admissionbtndisable').attr('disabled', false);
                        this.translate.get('header.finish').subscribe((translatedText: string) => { $('#admissionbtndisable').text(translatedText);});
                        const addNewStudentFailedTranslation = await firstValueFrom(this.translate.get('header.addNewStudentFailed')); 
                        customToastr(addNewStudentFailedTranslation + ' <br>' + data.message, 'error', 'New admission');
                        // this.avalialableTermsList=[];
                    } else if (data.errorcode === 10037) {
                        $('#admissionbtndisable').attr('disabled', false);
                        this.translate.get('header.finish').subscribe((translatedText: string) => { $('#admissionbtndisable').text(translatedText);});
                        const only100StudentsAreAllowedToAddInTrailSubscriptionTranslation = await firstValueFrom(this.translate.get('header.only100StudentsAreAllowedToAddInTrailSubscription')); 
                        customToastr(only100StudentsAreAllowedToAddInTrailSubscriptionTranslation, 'error');;
                    } else {
                        $('#admissionbtndisable').attr('disabled', false);
                        this.translate.get('header.finish').subscribe((translatedText: string) => { $('#admissionbtndisable').text(translatedText);});
                        const somethingWentWrongPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('header.somethingWentWrongPleaseTryAgain')); 
                        customToastr(somethingWentWrongPleaseTryAgainTranslation, 'error');
                    }
                },
                error => {
                    // callback(false)
                    // TODO: Show error message
                }
            );
    }

    uploadNewAdmissionImage(imageData, callback) {
        this.admissionservice.uploadImage(imageData, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    callback(data);
                },
                error => {
                    callback(false);
                }
            );
    }

    updateSelectedAcademic(academicId: string): void {
        this.selectedAcademicYearObj = academicId;
    }

    updateSelectedCategory(categoryId: string): void {

        this.classSectionList = null;
        this.classSections = null;

        this.selectedCategory = categoryId;
        this.fetchCategoryDetails(this.selectedCategory);
    }

    updateSelectedClassSection(classId: string): void {
        this.selectedClassSection = classId;
        this.fetchClassSectionOnClassId(classId);

        this.fetchFeeComponentOfClass(this.selectedClassSection);
    }

    updateSelectedClassSectionId(classId: string): void {
        this.selectedClassSectionId = classId;
    }

    updateSelectedBusRoute(routeId: string): void {
        this.selectedBusRoute = routeId;
        this.iterateBusId(routeId);
        this.getStopsOfRoute(this.currentSchoolId, this.selectedBusRoute);
    }

    addStd_updateSelectedBusRoute(stopId: string): void {
        stopId = $('body').find('#bus-stop-selection-add').val();
        if (stopId === '0') {
            $('body').find('#bus-stop-selection-add').val(0);
            this.isTermsVisible = false;
        } else {
            let stopName = '';
            for (const item of this.busStopListData) {
                if (item.PkBusStopId === parseInt(stopId)) {
                    this.mTotalBusFees = item.fare;
                    stopName = item.BusStopName;
                }
            }
            this.isTermsVisible = true;
            this.transportservice.getBusListForStop(stopId, this.selectedAcademicYear, localStorage.getItem('usertoken'))
                .subscribe(
                    async (data: any) => {
                        this.busListData = data;
                        if (this.busListData.length === 0) {
                            const params = {param1: stopName};
                            const translation = await firstValueFrom(this.translate.get('header.thereAreNoBusesPassingThroughTheStop'));
                            customToastr(translation + stopName, 'error');
                        }
                    },
                    error => {
                        this.busListData = [];
                    }
                );
        }
    }

    addStd_updateSelectedBusStop(stopNumber: string): void {
        stopNumber = $('#bus-stop-selection-add').val();
        const h = this;
        this.busStopListData.forEach(item => {
            if (item.pkBusStopId === stopNumber) {
                h.mTotalBusFees = item.fare;
            }
        });
    }

    getLastRegNumber() {
        this.groupservice.getLastRegId(localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    if (data && data.GenerateStudentRegistrationId) {
                        this.generateStudentRegistrationId = data.GenerateStudentRegistrationId;
                    } else {
                        this.generateStudentRegistrationId = 'MANUAL';
                    }
                    if (data && data.registrationId) {
                        $('.last_registration_number').html('(Last Reg <b>' + data.registrationId + '</b>)');
                    } else {
                        $('.last_registration_number').text('');
                    }
                },
                error => {
                    $('.last_registration_number').text('');
                }
            );
    }
    getStudentCategoryList() {
        this.admissionservice.getStudentCategoriesFoAdmission(localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    if (data && data.length) {
                        this.studentCategoryListForAdmission = data;
                    } else {
                        this.studentCategoryListForAdmission = [];
                    }
                },
                error => {
                    this.studentCategoryListForAdmission = [];
                }
            );
    }
    /* Edit student related code */

    getProperNumberForDate(num) {
        if (num < 10) {
            return '0' + num;
        }

        return num;
    }


    isCurrentAcademicToOpenStudentForm = false;



    getIntlTelInputGlobals(): any {
        return (window as any).intlTelInputGlobals;
    }

    onChangeBusStopGetBusList(busId) {
        let stopId = $('#edit-student-bus-stop').val();
        if (stopId === null) {
            stopId = this.editStudentFormData.student.stopId;
        }
        $('#edit-student-bus-selection').html('');
        let html = '<option value=\'0\'>Not Assigned</option>';

        if (!stopId || stopId === '0' || stopId === 0) {
            this.busListDataEditStudent = [];
            $('body').find('#edit-student-bus-selection').html(html);
            $('body').find('#edit-student-bus-selection').val('0');
        } else {
            this.transportservice.getBusListForStop(stopId, this.selectedAcademicYear, localStorage.getItem('usertoken'))
                .subscribe(
                    async (data: any) => {
                        this.busListDataEditStudent = data;
                        if (this.busListDataEditStudent.length === 0) {
                            const thereAreNoBusesPassingThroughTheStopTranslation = await firstValueFrom(this.translate.get('header.thereAreNoBusesPassingThroughTheStop')); 
                            customToastr(thereAreNoBusesPassingThroughTheStopTranslation, 'error');
                        } else {
                            if (this.busListDataEditStudent.length > 0) {
                                for (const item of this.busListDataEditStudent) {
                                    const name = item.BusName + ' - ' + item.BusNumber + ' - ' + item.RouteName +
                                        ' (' + item.startStop + ' to ' + item.endStop + ') ' + '-' + ' (' + 'Capacity' + ' - ' + item.Capacity + ') ' +
                                        '-' + ' (' + 'Filled' + ' - ' + item.assignedStudents + ')';
                                    html += '<option value=\'' + item.pkBusId + '\'>' + name + '</option>';
                                }
                            }
                            $('#edit-student-bus-selection').append(html);
                            $('#edit-student-bus-selection').val(busId);
                        }
                    },
                    error => {
                        this.busListDataEditStudent = [];
                        $('body').find('#edit-student-bus-selection').append('');
                        $('body').find('#edit-student-bus-selection').val('0');
                    }
                );
        }
    }


    formatAcademicYear(year) {
        if (year) {
            const spl = year.split('-');
            return spl[0] + '-' + spl[1].substring(4, 2);

        }
        return '';
    }

    formatDOB(dob) {
        if (dob) {
            const date = new Date(dob);
            return this.getProperNumber(date.getDate()) + '.' + this.getProperNumber(date.getMonth() + 1) + '.' + date.getFullYear();
        }
        return '';
    }

    getProperNumber(num) {
        if (num < 10) {
            return '0' + num;
        }
        return num;
    }

    clear_selected_students() {
        $('#clear-selected-students').trigger('click');
    }

    clear_selected_staffs() {
  $('#clear-selected-staffs').trigger('click');
  $("body").find("#id-print-floating-button-staff").hide();
  $("input[type='checkbox']").prop('checked', false);
  
  // ✅ Trigger custom event
  $(document).trigger('clearStaffSelections');
}



    // function for open pop up for tc generation 
    openPopUpForTcGeneration() {
        this.isTcGenerationConfirm = false;
        $('#modalTc').modal('show');
    }
    // api call for tc geneartion
    async generateTcSelectedStudent() {
        try {
            this.isTcGenerationConfirm = true;
            this.tcGeneratedJob = false;
            const studentIds = $('#multiple-id-cards-trigger').text();
            const studentIdsArray = studentIds.split(',').map(id => parseInt(id, 10));
            const selectedAcademic = $('#multiple-id-cards-trigger').attr("selected-academic");
            const response = await firstValueFrom(this.headerservice.generateTcForStudent(studentIdsArray, selectedAcademic));
            const data = response as any;
            if (data.status && data.body) {
                this.tcJobId = data.body.jobDetails ? (data.body.jobDetails.jobId ? data.body.jobDetails.jobId : "") : "";
                this.tcGeneratedJob = true;
            }
        }
        catch (error) {
            $('#modalTc').modal('hide');
            this.tcJobId = "";
            this.tcGeneratedJob = true;
            if (error?.error?.message) {
                customToastr(error.error.message, this.tcGenerationStringsData.error);
            } else {
                customToastr(this.tcGenerationStringsData.errorMessage, this.tcGenerationStringsData.error);
            }
        }
    }

    // function for open tc page
    openTC() {
        $('#modalTc').modal('hide');
        this.router.navigate(['/tc']);
    }


    print_bulk_id_cards() {
        const studentIds = $('#multiple-id-cards-trigger').text();
        const selectedAcademic = $('#multiple-id-cards-trigger').attr("selected-academic");
        this.headerservice.getStudentIdCardDetails(studentIds.toString(), selectedAcademic, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    $('body').find('#student-id-preview-popup-open').trigger('click');
                    this.idCardDetails = data;

                },
                error => {
                    this.idCardDetails = { academicInfo: {}, studentInfo: [] };
                }
            );
    }

    openIdCardPreview() {

        const studentId = JSON.parse($('#fetched-std-details').text()).student.studentId;
        const selectedAcademic = $('#multiple-id-cards-trigger').attr("selected-academic");
        this.headerservice.getStudentIdCardDetails(studentId.toString(), selectedAcademic, localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    $('#student-id-preview-popup-open').trigger('click');
                    $('body').find('#edit-student-popup-close').trigger('click');

                    this.idCardDetails = data;
                    this.idCardDetails.studentInfo = [data.studentInfo];

                },
                error => {
                    this.idCardDetails = { academicInfo: {}, studentInfo: [] };
                }
            );
    }

    confirmToUpdateForFees() {
        this.updateStudentDetail();
    }

    updateStudentDetail() {
        this.loaderEditStudent = true;
        this.groupservice.updateStudentDetails(this.admissionObj, this.getAuthToken)
            .subscribe(
                async (data: any) => {
                    this.loaderEditStudent = false;
                    if (data.status === true) {
                       const studentDetailsUpdatedTranslation = await firstValueFrom(this.translate.get('header.studentDetailsUpdated')); 
                       customToastr(studentDetailsUpdatedTranslation, 'success');
                        $('#edit-student-popup-close').trigger('click');
                        $('#notificationpopupclose').trigger('click');
                        $('#confirm-student-details-updated').trigger('click');

                    } else {
                        if (data.message) {
                            customToastr(data.message, 'error');
                        } else {
                            const studentDetailsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('header.studentDetailsNotUpdatedPleaseTryAgain')); 
                            customToastr(studentDetailsNotUpdatedPleaseTryAgainTranslation, 'error');
                        }
                    }
                },
                async error => {
                    this.loaderEditStudent = false;
                    const studentDetailsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('header.studentDetailsNotUpdatedPleaseTryAgain')); 
                    customToastr(studentDetailsNotUpdatedPleaseTryAgainTranslation, 'error');
                    $('#notificationpopupclose').trigger('click');
                }
            );
    }

    /* End of Edit student related code */


    /* Header class configuration progress */
    updatePercentageText() {
        this.translate.get('schoolConfigured', { percent: this.classConfigPercentage }).subscribe((translatedText: string) => {
            $('#percent-text').html(translatedText);
        });
    }


    getClassConfigStatus() {
        this.classConfigPercentage = 0;
        this.headerservice.getClassConfigStatus('YES', localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    this.classConfigPercentage = this.calculatePercentage(data.achievedCount, data.totalCount, 100);
                    this.translate.get('schoolConfigured', { percent: this.classConfigPercentage }).subscribe((translatedText: string) => {
                        $('#percent-text').html(translatedText);
                    });
                    $('#percent-progress').attr('aria-valuenow', this.classConfigPercentage);
                    const ringCircumference = 2 * Math.PI * 16;
                    const ringOffset = ringCircumference - (this.classConfigPercentage / 100) * ringCircumference;
                    $('#percent-progress').css({
                        'stroke-dasharray': ringCircumference + ' ' + ringCircumference,
                        'stroke-dashoffset': ringOffset
                    });
                },
                error => {
                    this.classConfigPercentage = 0;
                }
            );
    }

    closeFeesNotification() {
        $('#edit-student-notificationForFeesForFees').addClass('hide');
        this.loaderEditStudent = false;
    }

    getClassConfigStatusList() {
        this.isProcessing = true;
        this.classConfigSearchTerm = '';
        this.classConfigOnlyIncomplete = false;
        this.classConfigList = [];
        this.headerservice.getClassConfigStatus('NO', localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    this.isProcessing = false;
                    this.classConfigList = data;
                },
                error => {
                    this.classConfigList = [];
                    this.isProcessing = false;
                }
            );
    }

    calculatePercentage(count, total, percentageFor) {
        const per = Math.round((count * percentageFor) / total);
        return isNaN(per) ? 0 : per;
    }

    private getClassConfigModuleFlags(c: any): boolean[] {
        return [
            c.classStudentMapped,
            c.timetableConfigured,
            c.isSectionClassMapped,
            c.isClassTeacherAssigned,
            c.classSubjectsMapping,
            c.teacherAssignedToSubject,
            c.isFeeConfigured
        ];
    }

    getClassConfigDoneCount(c: any): number {
        return this.getClassConfigModuleFlags(c).filter(Boolean).length;
    }

    get filteredClassConfigList(): any[] {
        let list = this.classConfigList || [];
        if (this.classConfigOnlyIncomplete) {
            list = list.filter((c: any) => this.getClassConfigDoneCount(c) < this.classConfigTotalModules);
        }
        if (this.classConfigSearchTerm && this.classConfigSearchTerm.trim()) {
            const term = this.classConfigSearchTerm.trim().toLowerCase();
            list = list.filter((c: any) => {
                const label = `${c.classNumber || ''} ${c.classDivision || ''}`.toLowerCase();
                return label.includes(term);
            });
        }
        return list;
    }

    get classConfigFullyConfiguredCount(): number {
        return (this.classConfigList || []).filter((c: any) => this.getClassConfigDoneCount(c) === this.classConfigTotalModules).length;
    }

    get classConfigConfiguredModulesCount(): number {
        return (this.classConfigList || []).reduce((sum: number, c: any) => sum + this.getClassConfigDoneCount(c), 0);
    }

    get classConfigPendingModulesCount(): number {
        const totalPossible = (this.classConfigList || []).length * this.classConfigTotalModules;
        return totalPossible - this.classConfigConfiguredModulesCount;
    }

    get classConfigOverallPercent(): number {
        const totalPossible = (this.classConfigList || []).length * this.classConfigTotalModules;
        return this.calculatePercentage(this.classConfigConfiguredModulesCount, totalPossible, 100);
    }

    onMatrixSectionClick(event: Event): void {
        const target = event.target as HTMLElement;
        const trigger = target.closest('.p-paginator .p-dropdown') as HTMLElement;
        if (!trigger) {
            return;
        }
        const reposition = () => {
            const overlays = document.body.querySelectorAll(':scope > .p-overlay');
            const overlay = overlays[overlays.length - 1] as HTMLElement;
            const panel = overlay?.querySelector('.p-dropdown-panel') as HTMLElement;
            if (!overlay || !panel) {
                return;
            }
            const triggerRect = trigger.getBoundingClientRect();
            const panelHeight = panel.offsetHeight;
            overlay.style.top = (window.scrollY + triggerRect.top - panelHeight - 4) + 'px';
            overlay.style.transformOrigin = 'bottom';
            /* appended to <body>, so it sits outside the modal's stacking
               context — without this it renders behind the modal (z-index 1050). */
            overlay.style.zIndex = '1060';
        };
        setTimeout(reposition, 0);
        setTimeout(reposition, 100);
    }

    destroyDataTable(table) {
        $('#' + table).DataTable().destroy();
    }

   initializeDataTable(table) {
    setTimeout(() => {  
        this.translate.get([
            'dataTables.emptyTable',
            'dataTables.search',
            'dataTables.lengthMenu',
            'dataTables.info',
            'dataTables.infoEmpty',
            'dataTables.paginate.next',
            'dataTables.paginate.previous',
        ]).subscribe(translations => {
            $('#' + table).DataTable({
                language: {
                    emptyTable: translations['dataTables.emptyTable'],
                    search: translations['dataTables.search'],
                    lengthMenu: translations['dataTables.lengthMenu'],
                    info: translations['dataTables.info'],
                    infoEmpty: translations['dataTables.infoEmpty'],
                    paginate: {
                        next: translations['dataTables.paginate.next'],
                        previous: translations['dataTables.paginate.previous']
                    }
                },
                aaSorting: []
            });
        });
    }, 100);
}


    async validateImage(id, progressbarId, imageEleId, certificateType) {
        const extension = $(id).val().split('.').pop().toLowerCase();
        const ExtListToUpload = new Array('jpeg', 'png', 'jpg', "pdf");
        const isValidFileExt = $.inArray(extension, ExtListToUpload);
        if (isValidFileExt === -1) {
            $(progressbarId).addClass('hide');
           const pleaseSelectAValidImageTypeOfJpegPngJpgPdfTranslation = await firstValueFrom(this.translate.get('header.pleaseSelectAValidImageTypeOfJpegPngJpgPdf')); 
           customToastr(pleaseSelectAValidImageTypeOfJpegPngJpgPdfTranslation, 'error');
            return false;
        } else {
            if ($(id).get(0).files[0].size > (1024 * 1024 * 20)) {
                $(progressbarId).addClass('hide');
                const imageSizeShouldNotExceed20MbTranslation = await firstValueFrom(this.translate.get('header.imageSizeShouldNotExceed20Mb')); 
                customToastr(imageSizeShouldNotExceed20MbTranslation, 'error');
                return false;
            } else {
                const file = $(id).get(0).files[0];

                if (file) {

                    const imageAadharElem = document.getElementById('new-addmission-student-aadhar-image-ele');
                    const pdfAadaharIconElem = document.getElementById('addmission-aadhar-pdf-icon');

                    const imageCasteElem = document.getElementById('new-admission-student-caste-image-ele');
                    const pdfCasteIconElem = document.getElementById('addmission-caste-pdf-icon');


                    const imageTcOrBirthElem = document.getElementById('new-addmission-student-tc-or-birth-image-ele');
                    const pdfTcOrBirthIconElem = document.getElementById('addmission-tc-or-birth-pdf-icon');


                    const divyangjanElem = document.getElementById('new-addmission-student-Divyangjan-image-ele');
                    const pdfDivyangjanIconElem = document.getElementById('addmission-divyangjan-pdf-icon');


                    const singleGirlElem = document.getElementById('new-addmission-student-single-girl-image-ele');
                    const singleGirlIconElem = document.getElementById('addmission-single-girl-pdf-icon');


                    const ewsElem = document.getElementById('new-addmission-student-EWS-image-ele');
                    const ewsIconElem = document.getElementById('addmission-EWS-pdf-icon');

                    if (file.type === 'application/pdf' && certificateType === "aadharReference") {
                        pdfAadaharIconElem.classList.remove('hide');
                        imageAadharElem.style.display = 'none';
                    } else if (file.type !== 'application/pdf' && certificateType === "aadharReference") {
                        pdfAadaharIconElem.classList.add('hide');
                        imageAadharElem.style.display = 'block';
                    }

                    if (file.type === 'application/pdf' && certificateType === "casteCertificate") {
                        pdfCasteIconElem.classList.remove('hide');
                        imageCasteElem.style.display = 'none';
                    } else if (file.type !== 'application/pdf' && certificateType === "casteCertificate") {
                        pdfCasteIconElem.classList.add('hide');
                        imageCasteElem.style.display = 'block';
                    }

                    if (file.type === 'application/pdf' && certificateType === "tcOrBirthCertificate") {
                        pdfTcOrBirthIconElem.classList.remove('hide');
                        imageTcOrBirthElem.style.display = 'none';
                    } else if (file.type !== 'application/pdf' && certificateType === "tcOrBirthCertificate") {
                        pdfTcOrBirthIconElem.classList.add('hide');
                        imageTcOrBirthElem.style.display = 'block';
                    }

                    if (file.type === 'application/pdf' && certificateType === "speciallyAbled") {
                        pdfDivyangjanIconElem.classList.remove('hide');
                        divyangjanElem.style.display = 'none';
                    } else if (file.type !== 'application/pdf' && certificateType === "speciallyAbled") {
                        pdfDivyangjanIconElem.classList.add('hide');
                        divyangjanElem.style.display = 'block';
                    }

                    if (file.type === 'application/pdf' && certificateType === "singleGirlChildCertificate") {
                        singleGirlIconElem.classList.remove('hide');
                        singleGirlElem.style.display = 'none';
                    } else if (file.type !== 'application/pdf' && certificateType === "singleGirlChildCertificate") {
                        singleGirlIconElem.classList.add('hide');
                        singleGirlElem.style.display = 'block';
                    }

                    if (file.type === 'application/pdf' && certificateType === "ewsCertificate") {
                        ewsIconElem.classList.remove('hide');
                        ewsElem.style.display = 'none';
                    } else if (file.type !== 'application/pdf' && certificateType === "ewsCertificate") {
                        ewsIconElem.classList.add('hide');
                        ewsElem.style.display = 'block';
                    }
                }

                const utilFun = {
                    imageIsLoadedForEditStudent(e) {
                        $(imageEleId).attr('src', e.target.result);
                        $(imageEleId).removeClass('hide');
                    }
                };
                if ($(id).get(0).files && $(id).get(0).files[0]) {
                    const reader = new FileReader();
                    reader.onload = utilFun.imageIsLoadedForEditStudent;
                    reader.readAsDataURL($(id).get(0).files[0]);
                }
                return true;
            }
        }
    }

    openNewAdmissionStudentAadharCopyUpload() {
        $('#new-addmission-student-aadhar-copy').trigger('click');
    }

    startUploadingNewAdmissionStudentAadharCopy() {
        if (this.validateImage('#new-addmission-student-aadhar-copy',
            '#new-addmission-student-aadhar-progressbar', '#new-addmission-student-aadhar-image-ele', "aadharReference")) {
            this.translate.get('header.change').subscribe((translatedText: string) => {
                $('#new-addmission-student-aadhar-copy-button').text(translatedText);
            });
        }
    }

    alreadyPaid() {

        this.headerservice.alreadyPaidInvoice(localStorage.getItem('usertoken'))
            .subscribe(
                (data: any) => {
                    console.log(data);
                },
                error => {
                    console.log('error ', error);
                }
            );
    }

    ////////// Phone numbers validation///
    mobileNumbersValidation() {
        const mobileNumberInput = $('#mobile-number');
        const fatherMobileNumberInput = $('#add-father-mobile-number')
        const motherMobileNumberInput = $('#add-student-mother-mobile-number');
        const guardianMobileNumberInput = $('#add-student-guardian-mobile-number-admission');
        mobileNumberInput.intlTelInput("destroy");
        fatherMobileNumberInput.intlTelInput("destroy");
        motherMobileNumberInput.intlTelInput("destroy");
        guardianMobileNumberInput.intlTelInput("destroy");
        const countryData = this.getIntlTelInputGlobals().getCountryData();
        const matchedCountry = countryData.find((country: any) => {
            return `${country.dialCode}` == this.countryCode;
        });

        // Initialize intlTelInput
        mobileNumberInput.intlTelInput({
            initialCountry: matchedCountry.iso2,
            separateDialCode: false,
            autoPlaceholder: 'off',
            autoFormat: false,
            nationalMode: false,
            formatOnDisplay: false,
            utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js',
        });

        motherMobileNumberInput.intlTelInput({
            initialCountry: matchedCountry.iso2,
            separateDialCode: false,
            autoPlaceholder: 'off',
            autoFormat: false,
            nationalMode: false,
            formatOnDisplay: false,
            utilsScript:
                'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js',
        });

        guardianMobileNumberInput.intlTelInput({
            initialCountry: matchedCountry.iso2,
            separateDialCode: false,
            autoPlaceholder: 'off',
            autoFormat: false,
            nationalMode: false,
            formatOnDisplay: false,
            utilsScript:
                'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js',
        });

        // Initialize fatherMobileNumberInput with default country as India
        fatherMobileNumberInput.intlTelInput({
            initialCountry: matchedCountry.iso2,
            separateDialCode: false,
            autoPlaceholder: 'off',
            autoFormat: false,
            nationalMode: false,
            formatOnDisplay: false,
            utilsScript:
                'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js',
        });


        // Handle country change on mobileNumberInput
        mobileNumberInput.on('countrychange', () => {
            mobileNumberInput.val('');
            const countryData = mobileNumberInput.intlTelInput('getSelectedCountryData');
            this.studentCountryCode = countryData.dialCode
        });

        fatherMobileNumberInput.on('countrychange', () => {
            fatherMobileNumberInput.val('');
            const countryData = fatherMobileNumberInput.intlTelInput('getSelectedCountryData');
            this.mCountryCode = countryData.dialCode
        });

        motherMobileNumberInput.on('countrychange', () => {
            motherMobileNumberInput.val('');
            const countryData = motherMobileNumberInput.intlTelInput('getSelectedCountryData');
            this.motherCountryCode = countryData.dialCode
        });

        guardianMobileNumberInput.on('countrychange', () => {
            guardianMobileNumberInput.val('');
            const countryData = guardianMobileNumberInput.intlTelInput('getSelectedCountryData');
            this.guardianCountryCode = countryData.dialCode
        });
    }

    handleDebounceMobileNumber(value: HTMLInputElement): void {
        this.mobileNumberValidator(value);
        if (this.addStudentMobileNumberParsed == "") {
            this.invalidMobileNumber = false;
        }
    }

    mobileNumberValidator(mobileNumberInput: HTMLInputElement): void {
        const fullNumber = $(mobileNumberInput).intlTelInput('getNumber');
        const phoneNumber = parsePhoneNumberFromString(fullNumber);
        if (!phoneNumber) {
            this.invalidMobileNumber = true;
            return;
        }
        const isValid = phoneNumber.isValid();
        const isPossible = phoneNumber.isPossible();
        this.invalidMobileNumber = !(isValid);
    }


    clearMobileNumberValues() {
        this.mCountryCode = this.brand.defaultCountryDialCode || '91';
        this.motherCountryCode = this.brand.defaultCountryDialCode || '91';
        this.studentCountryCode = this.brand.defaultCountryDialCode || '91';
        this.guardianCountryCode = this.brand.defaultCountryDialCode || '91';
        this.invalidMobileNumber = false
        this.addStudentMobileNumber = "";
        this.addStudentMobileNumberParsed = ""
        this.addStudentFatherMobileNumberInput = "";
        this.mFatherNumber = "";
        this.invalidAddStudentFatherMobileNumber = false;
        this.addNewStudentMotherNumberInput = "";
        this.mMotherNumber = '';
        this.invalidAddStudentMotherMobileNumber = false;
        this.addNewStudentGuardianNumberInput = "";
        this.invalidAddStudentGuardianMobileNumber = false;
        this.mGuardianNumber = "";
    }

    ////Father mobile number ///////


    handleDebounceAddStudentFatherMobileNumber(value: HTMLInputElement): void {
        this.addStudentMobileFatherNumberValidator(value);
    }

    addStudentMobileFatherNumberValidator(mobileNumberInput: HTMLInputElement): void {
        const fullNumber = $(mobileNumberInput).intlTelInput('getNumber');
        const phoneNumber = parsePhoneNumberFromString(fullNumber);
        if (!phoneNumber) {
            this.invalidAddStudentFatherMobileNumber = true;
            return;
        }
        const isValid = phoneNumber.isValid();
        this.invalidAddStudentFatherMobileNumber = !(isValid);
    }

    handleDebounceAddStudentMotherMobileNumber(value: HTMLInputElement): void {
        this.addStudentMobileMotherNumberValidator(value);
        if (this.addNewStudentMotherNumberInput == "") {
            this.invalidAddStudentMotherMobileNumber = false;
        }
    }

    addStudentMobileMotherNumberValidator(mobileNumberInput: HTMLInputElement): void {
        const fullNumber = $(mobileNumberInput).intlTelInput('getNumber');
        const phoneNumber = parsePhoneNumberFromString(fullNumber);
        if (!phoneNumber) {
            this.invalidAddStudentMotherMobileNumber = true;
            return;
        }
        const isValid = phoneNumber.isValid();
        this.invalidAddStudentMotherMobileNumber = !(isValid);
    }

    handleDebounceAddStudentGuardianMobileNumber(value: HTMLInputElement): void {
        this.addStudentMobileGuardianNumberValidator(value);
        if (this.addNewStudentGuardianNumberInput == "") {
            this.invalidAddStudentGuardianMobileNumber = false;
        }
    }


    addStudentMobileGuardianNumberValidator(mobileNumberInput: HTMLInputElement): void {
        const fullNumber = $(mobileNumberInput).intlTelInput('getNumber');
        const phoneNumber = parsePhoneNumberFromString(fullNumber);
        if (!phoneNumber) {
            this.invalidAddStudentGuardianMobileNumber = true;
            return;
        }
        const isValid = phoneNumber.isValid();
        this.invalidAddStudentGuardianMobileNumber = !(isValid);
    }

    //////////New fileds /////////

    openNewStudentTcOrBirthCopyUpload() {
        $('#new-addmission-student-tc-or-birth-copy').trigger('click');
    }

    startUploadingNewTcOrBirthCopy() {
        if (this.validateImage('#new-addmission-student-tc-or-birth-copy', '#new-addmission-student-tc-or-birth-progressbar', '#new-addmission-student-tc-or-birth-image-ele', "tcOrBirthCertificate")) {
            this.translate.get('header.change').subscribe((translatedText: string) => {
                $('#new-addmission-student-tc-or-birth-copy-button').text(translatedText);
            });
        }
    }

    openNewStudentEWSCopyUpload() {
        $('#new-addmission-student-EWS-copy').trigger('click');
    }

    startUploadingNewEWSCopy() {
        if (this.validateImage('#new-addmission-student-EWS-copy', '#new-addmission-student-EWS-progressbar', '#new-addmission-student-EWS-image-ele', "ewsCertificate")) {
            this.translate.get('header.change').subscribe((translatedText: string) => {
                $('#new-addmission-student-EWS-copy-button').text(translatedText);
            });
        }
    }

    openNewStudentDivyangjanCopyUpload() {
        $('#new-addmission-student-Divyangjan-copy').trigger('click');
    }

    startUploadingNewDivyangjanCopy() {
        if (this.validateImage('#new-addmission-student-Divyangjan-copy', '#new-student-Divyangjan-progressbar', '#new-addmission-student-Divyangjan-image-ele', "speciallyAbled")) {
            this.translate.get('header.change').subscribe((translatedText: string) => {
                $('#new-addmission-student-Divyangjan-copy-button').text(translatedText);
            });
        }
    }

    openNewStudentSingleGirlCopyUpload() {
        $('#new-addmission-student-single-girl-copy').trigger('click');
    }

    startUploadingNewSingleGirlCopy() {
        if (this.validateImage('#new-addmission-student-single-girl-copy', '#new-addmission-student-single-girl-progressbar', '#new-addmission-student-single-girl-image-ele', "singleGirlChildCertificate")) {
            this.translate.get('header.change').subscribe((translatedText: string) => {
                $('#new-addmission-student-single-girl-copy-button').text(translatedText);
            });
        }
    }

    openNewStudentCasteCopyUpload() {
        $('#new-admission-student-caste-copy').trigger('click');
    }

    startUploadingNewCasteCopy() {
        if (this.validateImage('#new-admission-student-caste-copy', '#new-admission-student-caste-progressbar', '#new-admission-student-caste-image-ele', "casteCertificate")) {
            this.translate.get('header.change').subscribe((translatedText: string) => {
                $('#new-admission-student-caste-copy-button').text(translatedText);
            });
        }
    }


    getFileTypeFromUrl(url: string): string {
        const extension = url.split('.').pop()?.toLowerCase();
        if (['pdf'].includes(extension)) {
            return 'application/pdf';
        } else if (['png', 'jpg', 'jpeg'].includes(extension)) {
            return 'image';
        } else {
            return 'unknown';
        }
    }
   

      openIdCard() {
    this.isIdCardGenerated = false;
    $("#idCard").modal("show");
    this.getTemplateIdCard();
  }

  openStaffIdCard() {
    this.isStaffIdCardGenerated = false;
    $("#idCardStaff").modal("show");
    this.getStaffTemplateIdCard();
  }
   
  closeIdCard() {
    $("#idCard").modal("hide");
    this.isIdCardGenerated = false;
  }

  closeStaffIdCard() {
    $('#idCardStaff').modal("hide");
    this.isStaffIdCardGenerated = false;
  }
    
  idCardTemplates = [];
  isFetchingIdCard : any= true;
  async getTemplateIdCard() {
    try {
      const response: any = await firstValueFrom(
        this.headerservice.getIdCardTemplate()
      );
      console.log("Response", response);
      if (response.status) {
        this.idCardTemplates = response.body.idCardTemplateList;

      }
              this.isFetchingIdCard = false
    } catch (error) {
              this.isFetchingIdCard = false
    }
  }

  staffIdCardTemplates = [];
  staffIsFetchingIdCard : any= true;
    async getStaffTemplateIdCard() {
        try {
            const response: any = await firstValueFrom(
                this.headerservice.getStaffIdCardTemplate()
            );
            if (response.status) {
                this.staffIdCardTemplates = response.body.idCardTemplateList;

            }
            this.staffIsFetchingIdCard = false
        } catch (error) {
            this.staffIsFetchingIdCard = false
        }
    }

  selectIdCard(id: any) {
    this.idCardTemplates = this.idCardTemplates.map((data) => ({
      ...data,
      isSelected: data.templateId === id,
    }));
  }

  selectedStaffIdCard(id: any) {
    this.staffIdCardTemplates = this.staffIdCardTemplates.map((data) => ({
        ...data,
        isSelected: data.templateId === id
    }))
  }

  getTemplateId(){
    return this.idCardTemplates.find((data)=>data.isSelected)
  }

  getStaffTemplateId() {
     return this.staffIdCardTemplates.find((data)=>data.isSelected)
  }

  isIdCardGenerated = false;
  isGeneratingId = false;

  async generateIdCard(){
    try{
          const studentIds = $("#multiple-id-cards-trigger").text();
            const studentIdArray = studentIds.split(',');
            if(this.getTemplateId().templateId==undefined){
                const pleaseSelectTemplateFirstTranslation = await firstValueFrom(this.translate.get('header.pleaseSelectTemplateFirst')); 
                customToastr(pleaseSelectTemplateFirstTranslation, 'error');
                return;
            }
            this.isGeneratingId = true;
        const body ={
            lang : "en",
            studentIdList : studentIdArray,
            academicId : this.academicId,
            templateId : this.getTemplateId().templateId
        }
        const response : any = await firstValueFrom(this.headerservice.generateIdCard(body))
        if(response.status){
               this.isIdCardGenerated = true;
        }
          this.isGeneratingId = false;
    }
    catch(error){
   this.isIdCardGenerated = false;
   this.isGeneratingId = false;
customToastr(error.error.message || "Something went wrong", "error");
    }
  }

    isStaffIdCardGenerated = false;
    isStaffGeneratingId = false;

    // function for generating staff id card
    async generateStaffIdCard() {
        try {
            const staffIds = $("#multiple-id-cards-trigger").text();
            const staffIdArray = staffIds.split(',');
            
            if (this.getStaffTemplateId().templateId == undefined) {
                const pleaseSelectTemplateFirstTranslation = await firstValueFrom(this.translate.get('header.pleaseSelectTemplateFirst'));
                customToastr(pleaseSelectTemplateFirstTranslation, 'error');
                return;
            }
            this.isStaffGeneratingId = true;
            const body = {
                lang: "en",
                staffIdList: staffIdArray,
                academicId: this.academicId,
                templateId: this.getStaffTemplateId().templateId
            } 
            const response: any = await firstValueFrom(this.headerservice.generateStaffIdCard(body))
            if (response.status) {
                this.isStaffIdCardGenerated = true;
            }
            this.isStaffGeneratingId = false;
        }
        catch (error) {
            this.isStaffIdCardGenerated = false;
            this.isStaffGeneratingId = false;
            customToastr(error.error.message || "Something went wrong", "error");
        }
    }


  navigateToIdCardPage(){
        $("#idCard").modal("hide");
     this.router.navigate(["/id-card", "student"]);
  }

  navigateToStaffIdCardPage() {
    $("#idCardStaff").modal("hide");
    this.router.navigate(["/id-card", "staff"]);
  }

}